import {
  Box,
  Button,
  Skeleton,
  CardHeader,
  CardContent,
  Card,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Tooltip,
  Typography,
  Divider,
  Pagination,
  Chip,
  CircularProgress,
  Backdrop,
  InputAdornment
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import EmailIcon from "@mui/icons-material/Email";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import PsychologyIcon from "@mui/icons-material/Psychology";
import { useDispatch, useSelector } from "react-redux";
import {
  AddAtsJobPostAction,
  UpdateAtsJobPostAction,
} from "../../../../../store/ATS/JobPost/Action";
import { GetUserCompanyConsultancyHelper } from "../../helper/AtsCompanyHelper";
import { GetAtsAllowedUsersHelper } from "../../helper/AtsUserHelper";
import FormGroup from "@mui/material/FormGroup";
import { getUserData } from "../../../Base/helper/baseFunctions";
import Switch from "@mui/material/Switch";
import Quill from "../../../Base/views/Quill";
import LinearProgress from "@mui/material/LinearProgress";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import { AddAtsJobKanbanHelper } from "../../helper/AtsJobKanbanHelper";
import AtsCandidateForm from "../ATSCandidate/AtsCandidateForm";
import { GetAtsProfileScoreAction } from "../../../../../store/ATS/ProfileScore/Action";
import CreatableSearch from "../../../Base/views/CreatableSearch";
import {
  AddIndustryTypeHelper,
  GetIndustryTypeHelper,
} from "../../helper/Ancillary/IndustryTypeHelper";
import AtsJobTemplatePreview from "./AtsJobTemplatePreview";
import {
  GetJobTemplateAction,
} from "../../../../../store/ATS/JobTemplate/Action";
import {
  AddSkillsHelper,
  GetSkillsHelper,
} from "../../helper/Ancillary/SkillsHelper";
import ArrowBackButton from "../../../Base/views/ArrowBackButton";
import Base from "../../../Base/views/Base";
import history from "../../../../../history";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { GetJobTemplateHelper } from "../../helper/Ancillary/JobTemplateHelper";
import { ProposeCandidateConfirmationAction } from "../../../../../store/ATS/Candidate/Action";
import Popup from "../../../Base/views/Popup";
import FormBuilder from "../../../ATSSettings/views/FormBuilder/FormBuilder";
import {
  GetFormTemplateHelper,
  GetOfferLetterTemplateHelper,
} from "../../../ATSSettings/helper/AtsFormTemplateHelper";
import { AddMenuHeadingAction } from "../../../../../store/Menu/Action";
import { GetAtsJobOfferHelper } from "../../helper/JobPostHelper";
import { GetAtsGroupCompanyAction } from "../../../../../store/ATS/GroupCompany/Action";
import { PowerUserDisabledAction } from "../../../../../store/RoleAccess/Permission/Action";
import { AddJobSelectionModal } from "../../helper/Ancillary/AddJobCTA";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import WorkIcon from '@mui/icons-material/Work';
import { createStyles, makeStyles } from "@mui/styles";
import { JobInfoPreview, AICreateJobFlowDetails } from "../../helper/Ancillary/AICreateJobFlowDetails";
import AICongifWarningPopup from "../../helper/Ancillary/AICongifWarningPopup";
import AILineLoader from "../../../Ancillary/AnimationComponents/FramerAnimation";
import { CustomTextField } from "../../../Base/views/CustomComponents";
import CreateJobStepper from "./AIJob/CreateJobStepper";
import { GetPreScreenTemplateAction } from "../../../../../store/ATS/FormTemplate/Action";
import EditScreeningQuestionsDialog from "./AIJob/ScreeningQuestionDialog";
import PreScreen from "../../../ATSSettings/views/PreScreen/PreScreen";
import { fnAddJobMprHelper, fnDeleteJobMprHelper, fnGetJobMprHelper, fnGetAvailableJobMprHelper, GetMprApproverListHelper } from "../../helper/AtsMprRequestHelper";
import { GetBusinessUnitAction } from "../../../../../store/Ancillary/BusinessUnit/Action";

const AtsJobPostForm = ({
  editedRecord,
  jobPostFormMode,
  setJobPostFormMode,
  canEdit,
}) => {
  const initialValues = {
    primary_recruiter_id: [],
    title: [],
    ats_company_id: "",
    ats_grouporg_id: "",
    consultancy_id: [],
    job_location: "",
    status: "Active",
    preferred_qualification: "",
    min_exp_required: "",
    max_exp_required: "",
    preferred_gender: "All",
    min_salary: "",
    max_salary: "",
    vaccancies: "",
    job_position: "",
    secondary_recruiter_id: [],
    description: "",
    industry_type: [],
    job_type: "",
    remote_job: "Hybrid",
    priority: "Low",
    primary_skill: [],
    primary_skill_name: "",
    secondary_skill: [],
    secondary_skill_name: "",
    roles_responsibilities: "",
    make_public: true,
    feedback_template_id: "",
    prescreen_template_id: "",
    offer_letter: false,
    offer_letter_template_id: "",
    approver_ats_users_id: "",
    second_approver_ats_users_id: "",
    prescreen_template_json: [],
    video_prescreen_template_json: [],
    is_ai_job: false,
    prescreen_random_freq: {
      prequestion_random_freq: "",
      video_random_freq: ""
    },
    recruitment_manager_id: "",
    mpr_id: "",
    businessunit_fk: "",
    designation: ""
  };
  const dispatch = useDispatch();
  const classes = useStyles();
  const { getsuggestions, isLoading } = useSelector(
    (state) => state.AtsReducer?.AtsProfileScoreReducer
  );
  const { atsGroupCompanyData } = useSelector(
    (state) => state.AtsReducer?.AtsGroupCompanyReducer
  );
  const { open, fixedMenu, isMobile } = useSelector(
      (state) => state?.MenuReducer
  );
  const { featuresData } = useSelector(state => state?.RoleAndAccessReducer?.ATSModuleFeaturesReducer);
  const { prescreenData } = useSelector(state => state?.AtsReducer?.FormTemplateReducer)
  const { businessunitData } = useSelector((state) => state?.AncillaryReducer?.BusinessUnitReducer);
  
  const [buOption, setBuOption] = useState({load: true,values: []});
  const [templateData, setTemplateData] = useState({ load: true, values: [] });
  const [offertemplateData, setOfferTemplateData] = useState({
    load: true,
    values: [],
  });
  const [jobPostData, setPostJobData] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [primaryRecruiterData, setPrimaryRecruiterData] = useState({
    load: true,
    values: [],
  });
  const [recruiterManagerData, setRecruiterManagerData] = useState({
    load: true,
    values: [],
  });
  const [secondaryRecruiterData, setSecondaryRecruiterData] = useState({
    load: true,
    values: [],
  });
  const [mprData, setMprData] = useState({
    load: true,
    values: [],
  });
  const [atsCompanyData, setAtsCompanyData] = useState([]);
  const [atsConsultancyData, setAtsConsultancyData] = useState([]);
  const [companyData, setCompanyData] = useState({ load: true, values: [] });
  const [atsgroupUser, setAtsGroupUser] = useState({
    load: true,
    values: [],
  });
  const [consultancyData, setConsultancyData] = useState({
    load: true,
    values: [],
  });
  const [jobTitle, setJobTitle] = useState({ load: true, values: [] });
  const [industrytype, setIndustrytype] = useState({ load: true, values: [] });
  const [feedbackTemplate, setFeedackTemplate] = useState({
    load: true,
    values: [],
  });
  const [prescreenTemplate, setPrescreenTemplate] = useState({
    load: true,
    values: [],
  });
  const [offerTemplate, setOfferTemplate] = useState({
    load: true,
    values: [],
  });
  const [approverOptions, setApproverOptions] = useState([]);
  const [approverListData, setApproverListData] = useState({
    load: true,
    values: [],
  });
  const [candidatePreview, setCandidatePreview] = useState(false);
  const [currentData, setCurrentData] = useState();
  const [data, setData] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [formBuilder, setFormBuilder] = useState(false);
  const [builderTitle, setBuilderTitle] = useState("");
  const [preformBuilder, setPreFormBuilder] = useState(false);
  const [prebuilderTitle, setPreBuilderTitle] = useState("");
  const [anchorE, setAnchorE] = useState(null);
  const [toggle, setToggle] = useState(false);
  const [offerstatus, setOfferStatus] = useState("");
  const [rolesresponsibilities, setRolesResponsibilities] = useState("");
  const [description, setDescription] = useState("");
  const [anchor, setAnchor] = useState(false);
  const [drawerdata, setDrawerdata] = useState([]);
  const [skills, setSkills] = useState({ load: true, values: [] });
  const [skills2, setSkills2] = useState({ load: true, values: [] });
  const [page, setPage] = useState(1);
  const location = useLocation();
  const from = location.state ? location.state.from : null;
  const dashboard = [from];
  const dashBoard = dashboard?.[0] ? true : false; // isAddJob
  // from MPR Create Job
  const {from : fromMpr, mpr_data} = location.state || {};
  const isAddJobFromMPR = !!(fromMpr === "mpr_request" && mpr_data?.mpr_requests_pk)
  const userData = getUserData();
  const isGroupOrgFlowTrue = userData?.grouporg_flow === true;
  const showCandidate = getsuggestions.length === 0;
  const [modalOpen, setModalOpen] = useState(dashBoard && !candidatePreview);
  const [selectedOption, setSelectedOption] = useState("");
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [isMprLoading, setIsMprLoading] = useState(!!editedRecord?.ats_jobpost_id);

  useEffect(() => {
    dispatch(GetAtsGroupCompanyAction());
    if (editedRecord) {
      setIsMprLoading(true);
      GetAtsJobOfferHelper({
        ats_jobpost_id: editedRecord.ats_jobpost_id,
      }).then((res) => {
        setOfferStatus(res?.data?.data?.[0]?.fn_ats_getjobpost_offer_status)
      });
      // MPR mapped to jobs
      fnGetJobMprHelper({ ats_jobpost_fk: editedRecord?.ats_jobpost_id }).then((res) => {
        const mprObj = res?.data.data?.[0]?.fn_get_job_mpr?.[0] || "";
        const formattedMpr = mprObj?.mpr_id
          ? {
              ...mprObj,
              mpr_display: mprObj?.hiring_type ? `${mprObj.mpr_no} - ${mprObj.hiring_type}` : mprObj?.mpr_no,
            }
          : "";
        setPostJobData((prev) => ({
          ...prev,
          mpr_id: formattedMpr,
          approver_ats_users_id: mprObj?.approver_ats_users_id ? {
              ats_users_id: mprObj?.approver_ats_users_id,
              name: mprObj?.approver_name || "",
            } : ""
          ,
          second_approver_ats_users_id: mprObj?.second_approver_ats_users_id ? {
              ats_users_id: mprObj?.second_approver_ats_users_id,
              name: mprObj?.second_approver_name || "",
            } : "",
          previous_mpr_id: mprObj?.id || null
        }));
      }).finally(() => {
        setIsMprLoading(false);
      });
    }

    if (isAddJobFromMPR && mpr_data) {
      setPostJobData((jobPostData) => ({
        ...jobPostData,
        mpr_id: {
          ...mpr_data,
          mpr_display: mpr_data?.hiring_type
            ? `${mpr_data.mpr_no} - ${mpr_data.hiring_type}`
            : mpr_data.mpr_no,
        },
        vaccancies: mpr_data?.approved_headcount || jobPostData.vaccancies,
        job_location: mpr_data?.location || jobPostData.job_location,
        min_salary: mpr_data?.min_salary || jobPostData.min_salary,
        max_salary: mpr_data?.max_salary || jobPostData.max_salary,
        ...(mpr_data?.bu_fk && {
          businessunit_fk: {
            businessunit_id: mpr_data?.bu_fk,
            name: mpr_data?.businessunit_name,
          },
        }),
        ...((mpr_data?.approver_employee_id || mpr_data?.approver_id) && {
          approver_employee_id: {
            ats_users_id: mpr_data?.approver_employee_id || mpr_data?.approver_id,
            name: mpr_data?.approver_name || mpr_data?.approver_emp_name || "",
          },
        }),
        ...((mpr_data?.second_approver_employee_id || mpr_data?.second_approver_id) && {
          second_approver_employee_id: {
            ats_users_id: mpr_data?.second_approver_employee_id || mpr_data?.second_approver_id,
            name: mpr_data?.second_approver_emp_name || mpr_data?.second_approver_name || "",
          },
        }),
      }));
      if (mpr_data?.jd) {
        setDescription(mpr_data.jd);
      }
    }

    if (userData?.user_type !== "Consultancy") {
      handleToggle({ target: { checked: true } });
    }

    if (
      (jobPostFormMode !== "Add" && jobPostFormMode !== undefined) ||
      !dashBoard
    ) {
      let consultancy = editedRecord?.consultancy
        ? JSON.parse(editedRecord?.consultancy)
        : [];
      setPostJobData((prev) => ({
        ...prev,
        ...editedRecord,
        ats_company_id: editedRecord?.ats_company_id
          ? {
            ats_company_id: editedRecord?.ats_company_id,
            company: editedRecord?.company,
          }
          : "",
        ats_grouporg_id: editedRecord?.ats_grouporg_id
          ? {
            ats_grouporg_id: editedRecord?.ats_grouporg_id,
            name: editedRecord?.grouporg,
          }
          : "",
        primary_recruiter_id: editedRecord?.precruiter
          ? {
            recruiter_id: editedRecord?.precruiter?.[0]?.recruiter_id,
            recruiter: editedRecord?.precruiter?.[0]?.recruiter,
          }
          : "",
        secondary_recruiter_id:
          editedRecord?.srecruiter?.length > 0 ? editedRecord?.srecruiter : [],
        consultancy_id:
          consultancy?.length > 0
            ? consultancy.filter((row) => row?.consultancy_id !== null)
            : [],
        priority: editedRecord?.priority,
        industry_type: editedRecord?.industry_type
          ? {
            industry_type_id: editedRecord?.industry_code,
            industry_name: editedRecord?.industry_type,
            code: editedRecord?.industry_code,
          }
          : "",
        title: editedRecord?.title
          ? {
            job_title: editedRecord?.title,
            job_template_id: editedRecord?.job_title_id,
          }
          : "",
        primary_skill: editedRecord?.primary_skills_json
          ? JSON.parse(editedRecord?.primary_skills_json)
          : [],
        secondary_skill: editedRecord?.secondary_skills_json
          ? JSON.parse(editedRecord?.secondary_skills_json)
          : [],
        feedback_template_id: editedRecord?.feedback_template_id
          ? {
            template_id: editedRecord?.feedback_template_id,
            template_name: editedRecord?.template_name,
          }
          : "",
        prescreen_template_id: editedRecord?.prescreen_template_id
          ? {
            prescreen_template_id: editedRecord?.prescreen_template_id,
            prescreen_template_name: editedRecord?.prescreen_template_name,
          }
          : "",
        offer_letter_template_id: editedRecord?.offer_letter_template_id
          ? {
            offer_letter_template_id: editedRecord?.offer_letter_template_id,
            offer_letter_template_name:
              editedRecord?.offer_letter_template_name,
          }
          : "",
        approver_employee_id: editedRecord?.approver_employee_id
          ? {
              ats_users_id: editedRecord?.approver_employee_id,
              name: editedRecord?.approver_name || "",
            }
          : "",
        second_approver_employee_id: editedRecord?.second_approver_employee_id
          ? {
              ats_users_id: editedRecord?.second_approver_employee_id,
              name: editedRecord?.second_approver_emp_name || "",
            }
          : "",
        recruitment_manager_id: editedRecord?.recruitment_manager_id ? {
          recruiter_id: editedRecord?.recruitment_manager_id,
          recruiter: editedRecord?.recruitment_manager_name,
        } : "",
        businessunit_fk: editedRecord?.businessunit_fk
          ? {
            businessunit_id: editedRecord?.businessunit_fk,
            name: editedRecord?.businessunit_name,
          }
          : "",
      }));
      setRolesResponsibilities(editedRecord?.roles_responsibilities);
      setDescription(editedRecord?.description);
      setToggle(editedRecord?.is_internal || (isGroupOrgFlowTrue && userData?.user_type === "Group User") ? true : false);
    }
    GetUserCompanyConsultancyHelper().then((res) => {
      setAtsCompanyData(res?.data?.data?.[0]?.company);
      setAtsConsultancyData(res?.data?.data?.[0]?.consultancy);
      if (userData?.user_type === "Consultancy") {
        if (jobPostFormMode === "Add" || dashBoard) {
          setPostJobData((jobPostData) => ({
            ...jobPostData,
            consultancy_id: res?.data?.data?.[0]?.consultancy,
          }));
        }
      }
    });
    if (jobPostFormMode === "Preview") {
      getData();
    }
    GetFormTemplateHelper().then((res) => {
      setTemplateData({ load: false, values: res?.data?.data });
      if (jobPostFormMode === "Add" || dashBoard) {
        const defaultTemplate = res?.data?.data.find(
          (template) => template.is_default === true
        );
        // handleToggle({ 'target': { 'checked': true } })
        setPostJobData((jobPostData) => ({
          ...jobPostData,
          feedback_template_id: defaultTemplate
            ? {
              template_id: defaultTemplate?.template_id,
              template_name: defaultTemplate?.template_name,
            }
            : "",
        }));
      }
    });
    dispatch(GetPreScreenTemplateAction({}, (error, res) => {
      if (!error && res?.data?.statuscode === 200) {
        setPrescreenTemplate({ load: false, values: res?.data?.data });
        if (jobPostFormMode === "Add" || dashBoard) {
          populateDefaultPreScreeningTemplate(res?.data?.data)
        }
      }
    }));

    GetOfferLetterTemplateHelper().then((res) => {
      setOfferTemplateData({ load: false, values: res?.data?.data });
    });
    GetMprApproverListHelper().then((res) => {
      if (res?.data?.statuscode === 200) {
        const list = res?.data?.data?.[0]?.approver_json || [];
        setApproverOptions(list);
        setApproverListData({ load: false, values: list });
      }
    });
    dispatch(GetBusinessUnitAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!editedRecord, !candidatePreview]);
  const handleApproverList = (type) => {
    if (approverOptions?.length) {
      const excludeId =
        type === "approver"
          ? jobPostData?.second_approver_ats_users_id?.ats_users_id
          : type === "second_approver"
          ? jobPostData?.approver_ats_users_id?.ats_users_id
          : null;

      const filtered = approverOptions.filter(
        (el) => Number(el?.ats_users_id) !== Number(excludeId)
      );

      setApproverListData({
        load: false,
        values: filtered,
      });
    } else {
      setApproverListData({
        load: false,
        values: approverOptions,
      });
    }
  };

  const populateDefaultPreScreeningTemplate = (data = prescreenData || []) => {
    const defaultTemplate = data?.find(
      (template) => template.is_default === true
    );
    setPostJobData((jobPostData) => ({
      ...jobPostData,
      prescreen_template_id: defaultTemplate
        ? {
          prescreen_template_id: defaultTemplate?.prescreen_template_id,
          prescreen_template_name:
            defaultTemplate?.prescreen_template_name,
          prescreen_template_fields: defaultTemplate?.prescreen_template_fields
        }
        : "",
      prescreen_template_json: defaultTemplate?.prescreen_template_fields || [],
      video_prescreen_template_json: defaultTemplate?.video_prescreen_template_fields || []
    }));
  }

  const handleDisabled = (permission) => {
    let value = featuresData?.find(item => item?.permission === permission)
    return value ? false : true
  }
  const getData = (e) => {
    dispatch(
      GetAtsProfileScoreAction({
        domain: userData?.domain,
        ats_jobpost_id: editedRecord.ats_jobpost_id,
        page_number: typeof e === "number" ? e : 1,
        page_size: 12,
      })
    );
  };
  const tabTypeIndex = sessionStorage.getItem("tabTypeIndex");
  let state;
  if (tabTypeIndex === "0") {
    state = "Active";
  } else if (tabTypeIndex === "1") {
    state = "Inactive";
  } else if (tabTypeIndex === "2") {
    state = "Archive";
  }
  const handlePagination = (event, value) => {
    setPage(value);
    getData(value);
  };
  const proposeCandidate = (value) => {
    setData(value);
    setAnchorE(null);
    setOpenDialog(true);
  };
  const handleClickPreview = (value) => {
    setCurrentData(value);
    setCandidatePreview(true);
  };
  const handleConfirmPropose = () => {
    AddAtsJobKanbanHelper({
      kanban_data: JSON.stringify([
        {
          proposed_by: userData?.ats_user_id,
          candidate_id: data?.candidate_id,
          ats_jobpost_id: editedRecord?.ats_jobpost_id,
          comment: null,
          ats_job_stages_id: null,
          priority: 5,
          ats_status_id: null,
          mpr_requests_fk: null
        },
      ]),
    }).then((res) => {
      if (res?.data?.statuscode === 200) {
        const kanbanUserData = res?.data?.data?.find(
          (item) => item?.candidate_id === data?.candidate_id
        );
        dispatch(
          ProposeCandidateConfirmationAction({
            candidate_data: data,
            job_data: currentData,
            kanban_data: kanbanUserData,
          })
        );
      }
      getData();
    });
    setOpenDialog(false);
  };
  const validate = (fieldValues, description, rolesresponsibilities) => {
    let temp = { ...errors };
    if ("title" in fieldValues) {
      temp.title =
        fieldValues.title?.length === 0
          ? "Job Title is required"
          : fieldValues?.title === null
            ? "Job Title is required"
            : "";
    }
    if ("industry_type" in fieldValues) {
      temp.industry_type =
        fieldValues.industry_type?.length === 0
          ? "Industry Sector is required"
          : fieldValues?.industry_type === null
            ? "Industry Sector is required"
            : "";
    }
    if (isGroupOrgFlowTrue) {
      if ("ats_grouporg_id" in fieldValues) {
        temp.ats_grouporg_id =
          fieldValues.is_internal === true
            ? ""
            : fieldValues.ats_grouporg_id === ""
              ? "Group Org is required"
              : "";
      }
    }
    else {
      if ("ats_company_id" in fieldValues) {
        temp.ats_company_id =
          jobPostData.is_internal === true
            ? ""
            : fieldValues.ats_company_id === ""
              ? "Client is required"
              : "";
      }
    }

    if ("job_location" in fieldValues) {
      temp.job_location = ["", null].includes(fieldValues.job_location?.trim())
        ? "Job Location is required"
        : "";
    }
    if ("vaccancies" in fieldValues) {
      temp.vaccancies =
        fieldValues.vaccancies === "" ? "Vacancies is required" : "";
    }
    if ("primary_skill" in fieldValues) {
      temp.primary_skill =
        fieldValues.primary_skill?.length === 0
          ? "Primary Skill is required"
          : fieldValues.primary_skill === null
            ? "Primary Skill is required"
            : "";
    }
    if ("primary_recruiter_id" in fieldValues) {
      temp.primary_recruiter_id =
        fieldValues.primary_recruiter_id?.length === 0
          ? "Primary Recruiter is required"
          : fieldValues.primary_recruiter_id === null
            ? "Primary Recruiter is required"
            : "";
    }
    if ("recruitment_manager_id" in fieldValues) {
      temp.recruitment_manager_id =
        !fieldValues.recruitment_manager_id
          ? "Recruiter Manager is required"
          : "";
    }
    if ("min_salary" in fieldValues) {
      temp.min_salary = !fieldValues?.min_salary
        ? "Minimum salary is required"
        : !fieldValues?.max_salary
          ? ""
          : +fieldValues?.max_salary < +fieldValues?.min_salary
            ? "Minimum salary must be lesser than Maximum salary"
            : "";
    }
    if ("max_salary" in fieldValues) {
      temp.max_salary = (!fieldValues?.max_salary && jobPostData?.offer_letter && (!jobPostData?.mpr_id || !jobPostData?.mpr_id?.is_budgeted))
        ? "Maximum salary is required"
        : !fieldValues?.max_salary ? ""
        : +fieldValues?.min_salary && +fieldValues?.max_salary < +fieldValues?.min_salary
          ? "Maximum salary must be greater than Minimum salary"
          : "";
    } else {
      temp.max_salary = "";
    }
    if ("min_exp_required" in fieldValues) {
      temp.min_exp_required =
        fieldValues?.max_exp_required === ""
          ? ""
          : +fieldValues?.max_exp_required < +fieldValues?.min_exp_required
            ? "Minimum experience must be lesser than maximum experience"
            : "";
    }
    if ("description" in fieldValues) {
      temp.description =
        description === ""
          ? "Description is required"
          : description === "<p><br></p>"
            ? "Description is required"
            : "";
    }
    if ("roles_responsibilities" in fieldValues) {
      temp.roles_responsibilities =
        rolesresponsibilities === ""
          ? "Roles and Responsibilities are required"
          : rolesresponsibilities === "<p><br></p>"
            ? "Roles and Responsibilities are required"
            : "";
    }
    if ("offer_letter" in fieldValues) {
      if (fieldValues?.offer_letter) {
        temp.offer_letter_template_id =
          fieldValues?.offer_letter_template_id === ""
            ? "Offer Letter is required"
            : "";
      } else {
        temp.offer_letter_template_id = "";
      }
    } else temp.offer_letter_template_id = ""
    if ("approver_ats_users_id" in fieldValues && fieldValues?.offer_letter) {
      temp.approver_ats_users_id = !fieldValues?.approver_ats_users_id ? "Approver is required" : ""
    } else {
      temp.approver_ats_users_id = ""
    }
    if ("second_approver_ats_users_id" in fieldValues && fieldValues?.offer_letter) {
      temp.second_approver_ats_users_id = !fieldValues?.second_approver_ats_users_id ? "Approver is required" : ""
    } else {
      temp.second_approver_ats_users_id = ""
    }
    setErrors({
      ...temp,
    });
    const fieldsToCheck = Object.keys(fieldValues);

    return fieldsToCheck.every((field) => temp[field] === "" || !temp[field]);
    // return Object.values(temp).every((x) => x === "");
  };

  const handleChange = (event, value) => {
    if (["ats_company_id", "consultancy_id", "ats_grouporg_id"].includes(event)) {
      if (value)
        setPostJobData({
          ...jobPostData,
          [event]: value,
          primary_recruiter_id: [],
          secondary_recruiter_id: [],
          recruitment_manager_id: ""
        });
      else
        setPostJobData({
          ...jobPostData,
          [event]: "",
          primary_recruiter_id: [],
          secondary_recruiter_id: [],
          recruitment_manager_id: ""
        });
      setPrimaryRecruiterData({ load: true, values: [] });
      setSecondaryRecruiterData({ load: true, values: [] });
      setRecruiterManagerData({ load: true, values: [] });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ [event]: value ? value : "" });
    } else if (["primary_recruiter_id"].includes(event)) {
      if (value)
        setPostJobData({
          ...jobPostData,
          primary_recruiter_id: value,
          ...(value?.reportingmanager_id ? { recruitment_manager_id: { recruiter_id: value?.reportingmanager_id, recruiter: value?.reportingmanager_name } } : { recruitment_manager_id: "" })
        });
      else
        setPostJobData({
          ...jobPostData,
          primary_recruiter_id: "",
        });
      setSecondaryRecruiterData({ load: true, values: [] });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ primary_recruiter_id: value ? value : [], ...(value?.reportingmanager_id ? { recruitment_manager_id: { recruiter_id: value?.reportingmanager_id, recruiter: value?.reportingmanager_name } } : { recruitment_manager_id: "" }) });
    } else if (["primary_skill", "secondary_skill"].includes(event)) {
      if (value) {
        const inputValues = value?.filter(
          (row) =>
            row.inputValue &&
            row.skill &&
            +value.findIndex(
              (obj) => obj?.inputValue === value.at(-1)?.inputValue
            ) ===
            +value?.length - 1
        );
        const skillNames = value
          ?.map((row) => row.inputValue || row.skill)
          .join(", ");
        if (
          inputValues?.length > 0 &&
          jobPostData?.industry_type?.industry_type_id
        ) {
          const existingSkills = jobPostData[event] || [];
          const newSkills = inputValues?.filter(
            (row) =>
              !existingSkills.some((skill) => skill?.skill === row?.skill)
          );
          if (newSkills.length > 0) {
            const updatedSkills = [
              ...existingSkills,
              ...newSkills.map((newSkill) => ({ skill: newSkill.inputValue })),
            ];
            const newSkillNames = updatedSkills
              .map((skill) => skill.skill)
              .join(", ");
            newSkills.forEach((newSkill) => {
              AddSkillsHelper({
                industry_code: jobPostData?.industry_type?.code,
                skill_name: newSkill.inputValue,
              }).then((res) => {
                if (res?.data?.statuscode === 200 && res?.data?.data.length > 0)
                  setSkills({ load: false, values: res?.data?.data });
              });
            });
            setPostJobData({
              ...jobPostData,
              [event]: updatedSkills,
              [event === "primary_skill"
                ? "primary_skill_name"
                : "secondary_skill_name"]: newSkillNames,
            });
          }
        } else {
          setPostJobData({
            ...jobPostData,
            [event]: value,
            [event === "primary_skill"
              ? "primary_skill_name"
              : "secondary_skill_name"]: skillNames,
          });
        }
      } else setPostJobData({ ...jobPostData, [event]: [] });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ [event]: value ? value : [] });
    } else if (["secondary_recruiter_id", "recruitment_manager_id"].includes(event)) {
      if (value) {
        setPostJobData({ ...jobPostData, [event]: value });
      } else setPostJobData({ ...jobPostData, [event]: [] });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ [event]: value ? value : [] });
    } else if (["title"].includes(event)) {
      if (value) {
        setPostJobData({ ...jobPostData, [event]: value });
        if (selectedOption !== "ai") {
          if (jobPostData?.mpr_id && dashBoard) {
              setRolesResponsibilities(value?.roles_responsibilities || "");
              setDescription(jobPostData?.mpr_id?.jd || value?.job_description || "");
          } else {
            toggleDrawer(true, value, jobPostData);
          }
        }

      } else setPostJobData({ ...jobPostData, title: [] });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ title: value ? value : [] });
    } else if (["mpr_id", "businessunit_fk"].includes(event)) {
      const isMprEvent = event === "mpr_id"; // during add job only
      if (value) {
        const formattedVal = isMprEvent
          ? {
              ...value,
              mpr_display: value?.hiring_type ? `${value.mpr_no} - ${value.hiring_type}` : value.mpr_no,
            }
          : value;
        setPostJobData({ ...jobPostData, 
          [event]: formattedVal,
          ...(isMprEvent && {
              businessunit_fk: value?.bu_fk
              ? {
                businessunit_id: value?.bu_fk,
                name: value?.businessunit_name,
                } : "",
                vaccancies: value?.approved_headcount,
                job_location: value?.location,
                min_salary: value?.min_salary || "",
                max_salary: value?.max_salary || "",
              })
         });
         isMprEvent && setDescription(value?.jd || "");
      } else {
        setPostJobData({ ...jobPostData, 
          [event]: "",
          ...(isMprEvent && {
            businessunit_fk: "",
            vaccancies: "",
            job_location: "",
            min_salary: "",
            max_salary: "",
            approver_ats_users_id: "",
            second_approver_ats_users_id: ""
          })
        });
        isMprEvent && setDescription("");
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ [event]: value ? value : "" });
    } else if (["industry_type"].includes(event)) {
      if (value?.id === null) {
        AddIndustryTypeHelper({ industry_name: value?.industry_name }).then(
          (res) => {
            if (res.data?.statuscode === 200) {
              setIndustrytype({ load: false, values: res?.data?.data });
              setPostJobData({
                ...jobPostData,
                [event]: res?.data?.data?.filter(
                  (resp) => resp?.industry_name === value?.industry_name
                )?.[0],
                title: [],
              });
            }
          }
        );
      } else if (value)
        setPostJobData({
          ...jobPostData,
          [event]: value,
          title: [],
          primary_skill: [],
          secondary_skill: [],
        });
      else
        setPostJobData({
          ...jobPostData,
          [event]: [],
          title: [],
          primary_skill: [],
          secondary_skill: [],
        });
      toggleDrawer(false, value);
      setJobTitle({ load: true, values: [] });
      setSkills({ load: true, values: [] });
      setSkills2({ load: true, values: [] });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ industry_type: value ? value : [] });
    } else if (["feedback_template_id"].includes(event)) {
      if (value) {
        if (value?.id === null) {
          setFeedackTemplate({ load: false, values: [] });
          setBuilderTitle(value?.template_name);
          setFormBuilder(true);
        } else setPostJobData({ ...jobPostData, [event]: value });
      } else setPostJobData({ ...jobPostData, [event]: "" });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ feedback_template_id: value ? value : "" });
    } else if (["prescreen_template_id"].includes(event)) {
      if (value) {
        if (value?.id === null) {
          setPrescreenTemplate({ load: false, values: [] });
          setPreBuilderTitle(value?.prescreen_template_name); // Add new job AI
          (jobPostFormMode === "Edit" || !jobPostData?.is_ai_job) && setPreFormBuilder(true); // open only on Edit mode and non_ai_job
        } else {
          setPostJobData({
            ...jobPostData,
            [event]: value,
            prescreen_template_json: value?.prescreen_template_fields || [],
            video_prescreen_template_json: value?.video_prescreen_template_fields || []
          });
          setPreBuilderTitle("");
        }
      } else setPostJobData({ ...jobPostData, [event]: "" });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ prescreen_template_id: value ? value : "" });
    } else if (["offer_letter_template_id"].includes(event)) {
      if (value) {
        setPostJobData({ ...jobPostData, [event]: value });
      } else setPostJobData({ ...jobPostData, [event]: "" });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ offer_letter_template_id: value ? value : "" });
    } else if (["approver_ats_users_id", "second_approver_ats_users_id"].includes(event)) {
      if (value) {
        setPostJobData({ ...jobPostData, [event]: value });
        setApproverListData({ load: true, values: [] });
      } else {
        setPostJobData({ ...jobPostData, [event]: "" });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...jobPostData, [event]: value ? value : "" });
    } else if (["make_public"].includes(event.target.name)) {
      setPostJobData({
        ...jobPostData,
        [event.target.name]: event.target.value === "true" ? true : false,
      });
    } else if (["offer_letter"].includes(event?.target?.name)) {
      const isOffer = event.target.value === "true" ? true : false;
      setPostJobData({
        ...jobPostData,
        [event.target.name]: isOffer,
        ...(!isOffer && {
          offer_letter_template_id: "",
          approver_ats_users_id: "",
          second_approver_ats_users_id: "",
        }),
      });
      if (!isOffer) {
        setErrors((prev) => ({
          ...prev,
          offer_letter_template_id: "",
          approver_ats_users_id: "",
          second_approver_ats_users_id: "",
        }));
      }
    }
    else {
      setPostJobData({
        ...jobPostData,
        [event.target.name]: event.target.value,
      });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ [event.target.name]: event.target.value });
    }
  };
  const handleMPRChange = async (event, value) => {
     if (["mpr_id"].includes(event)) {
      if (value) {
        const isMprBudgeted = value?.is_budgeted === true
        setPostJobData({ ...jobPostData, 
          [event]: value,
          ...(!isMprBudgeted && {
            approver_ats_users_id: "",
            second_approver_ats_users_id: "",
          })
        });
      } else setPostJobData({ ...jobPostData, [event]: "" });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ [event]: value ? value : '' });
    }
  }
  
  const handleSubmit = (alreadyValidated = false) => {
    if (alreadyValidated || validate(jobPostData, description, rolesresponsibilities)) {
      let primary_recruiter = [];
      let secondary_recruiter = [];
      let consultancy = [];

      const preTotal = jobPostData?.prescreen_template_json?.length || 0;
      const videoTotal = jobPostData?.video_prescreen_template_json?.length || 0;
      const normalizedPreFreq = normalizeFrequency(
        jobPostData?.prescreen_random_freq?.prequestion_random_freq,
        preTotal
      );
      const normalizedVideoFreq = normalizeFrequency(
        jobPostData?.prescreen_random_freq?.video_random_freq,
        videoTotal
      );

      let data = {
        // primary_recruiter_id: jobPostData?.primary_recruiter_id?.recruiter_id || null,
        title: jobPostData?.title?.job_title,
        job_title_id: jobPostData?.title?.job_template_id || null,
        ats_company_id: +jobPostData?.ats_company_id?.ats_company_id || null,
        job_location: jobPostData?.job_location,
        status: jobPostData?.status,
        preferred_qualification: jobPostData?.preferred_qualification,
        min_exp_required: +jobPostData?.min_exp_required || null,
        max_exp_required: +jobPostData?.max_exp_required || null,
        preferred_gender: jobPostData?.preferred_gender,
        min_salary: +jobPostData?.min_salary || null,
        max_salary: +jobPostData?.max_salary || null,
        vaccancies: jobPostData?.vaccancies || null,
        job_position: jobPostData?.job_position,
        secondary_recruiter_id:
          jobPostData?.secondary_recruiter_id?.recruiter_id || null,
        description: description,
        industry_type: jobPostData?.industry_type?.industry_name,
        industry_code: jobPostData?.industry_type?.code || null,
        job_type: jobPostData?.job_type,
        remote_job: jobPostData?.remote_job || null,
        priority: jobPostData?.priority,
        primary_skill: jobPostData?.primary_skill_name,
        secondary_skill: jobPostData?.secondary_skill_name,
        // is_internal: toggle ? true : false,
        is_internal: (toggle && !(isGroupOrgFlowTrue && userData?.user_type === "Group User")) ? true : false,
        roles_responsibilities: rolesresponsibilities,
        primary_skills_json: jobPostData?.primary_skill,
        secondary_skills_json: jobPostData?.secondary_skill,
        make_public: jobPostData?.make_public,
        feedback_template_id: +jobPostData?.feedback_template_id?.template_id,
        prescreen_template_id:
          +jobPostData?.prescreen_template_id?.prescreen_template_id,
        offer_letter: jobPostData?.offer_letter,
        offer_letter_template_id:
          +jobPostData?.offer_letter_template_id?.offer_letter_template_id ||
          null,
        ats_grouporg_id: +jobPostData?.ats_grouporg_id?.ats_grouporg_id || +jobPostData?.ats_grouporg_id || null,
        prescreen_template_json: jobPostData?.prescreen_template_json || null,
        video_prescreen_template_json: jobPostData?.video_prescreen_template_json || null,
        is_ai_job: jobPostData?.is_ai_job,
        prescreen_random_freq: {
          prequestion_random_freq: normalizedPreFreq,
          video_random_freq: normalizedVideoFreq,
        },
        recruitment_manager_id: jobPostData?.recruitment_manager_id?.recruiter_id || null,
        businessunit_fk: jobPostData?.businessunit_fk?.businessunit_id || null,
        designation: jobPostData?.designation || null,
      };
      if (jobPostData?.primary_recruiter_id?.recruiter_id) {
        primary_recruiter.push({ primary_recruiter_id: +jobPostData.primary_recruiter_id.recruiter_id });
      }
      jobPostData?.secondary_recruiter_id?.length > 0 &&
        jobPostData?.secondary_recruiter_id?.forEach((res) =>
          secondary_recruiter.push({
            secondary_recruiter_id: +res?.recruiter_id,
          })
        );

      jobPostData?.consultancy_id?.length > 0 &&
        jobPostData?.consultancy_id?.forEach((res) =>
          consultancy.push({ consultancy_id: +res?.consultancy_id })
        );

      if (editedRecord?.ats_jobpost_id)
        data = { ...data, ats_jobpost_id: editedRecord?.ats_jobpost_id };
      if (jobPostData?.ats_jobpost_id) {
        dispatch(
          UpdateAtsJobPostAction({
            jobpost_data: JSON.stringify([data]),
            consultancy_id:
              consultancy?.length > 0 ? JSON.stringify(consultancy) : null,
            primary_recruiter:
              primary_recruiter?.length > 0
                ? JSON.stringify(primary_recruiter)
                : false,
            secondary_recruiter:
              secondary_recruiter?.length > 0
                ? JSON.stringify(secondary_recruiter)
                : false,
            tab_type: state,
          }, async (response) => {
              if (!response) return
            try {
              if (jobPostData?.previous_mpr_id) {
                await fnDeleteJobMprHelper({
                  ats_jobpost_mpr_mapping_pk: jobPostData?.previous_mpr_id,
                });
              }
              if (
                jobPostData?.mpr_id || jobPostData?.approver_ats_users_id?.ats_users_id || jobPostData?.second_approver_ats_users_id?.ats_users_id
              ) {
                fnAddJobMprHelper({
                  mpr_requests_fk: jobPostData?.mpr_id?.mpr_id,
                  ats_jobpost_fk: jobPostData?.ats_jobpost_id,
                  primary_approver_id: jobPostData?.approver_ats_users_id?.ats_users_id,
                  secondary_approver_id: jobPostData?.second_approver_ats_users_id?.ats_users_id,
                });
              }
            } catch (err) {
              console.error("Error updating MPR mapping:", err);
            }
            if (dashBoard) {
              history.push("/ats/manage-job");
              sessionStorage.setItem("selectedMenu", "Job Dashboard");
              dispatch(AddMenuHeadingAction({ heading: "Job Dashboard" }));
            } else {
              setJobPostFormMode("Card");
            }
          })
        );
      } else {
        dispatch(
          AddAtsJobPostAction({
            jobpost_data: JSON.stringify([data]),
            consultancy_id:
              consultancy?.length > 0 ? JSON.stringify(consultancy) : null,
            primary_recruiter:
              primary_recruiter?.length > 0
                ? JSON.stringify(primary_recruiter)
                : false,
            secondary_recruiter:
              secondary_recruiter?.length > 0
                ? JSON.stringify(secondary_recruiter)
                : false,
          }, (response) => {
            const newJobId= response?.data?.data?.[0]?.fn_ats_addjobpost_v1;
            if (newJobId && (jobPostData?.mpr_id || jobPostData?.approver_ats_users_id?.ats_users_id || jobPostData?.second_approver_ats_users_id?.ats_users_id)) {
                 fnAddJobMprHelper({
                  mpr_requests_fk: jobPostData?.mpr_id?.mpr_id, 
                  ats_jobpost_fk: newJobId,
                  primary_approver_id: jobPostData?.approver_ats_users_id?.ats_users_id,
                  secondary_approver_id: jobPostData?.second_approver_ats_users_id?.ats_users_id
                }).then((res) => {});
            }
            if (dashBoard) {
              history.push("/ats/manage-job");
              sessionStorage.setItem("selectedMenu", "Job Dashboard");
              dispatch(AddMenuHeadingAction({ heading: "Job Dashboard" }));
            }
            else {
              setJobPostFormMode("Card");
            }
          })
        );
      }
    }
  };


  const handleClose = () => {
    if (isAddJobFromMPR) {
      setPostJobData(initialValues);
      setErrors({});
      history.push("/ats/hiring-requests");
      sessionStorage.setItem("selectedMenu", "Hiring Request");
      dispatch(AddMenuHeadingAction({ heading: "Hiring Request" }));
    } else if (dashBoard) {
      setPostJobData(initialValues);
      setErrors({});
      history.push("/ats/manage-job");
      sessionStorage.setItem("selectedMenu", "Job Dashboard");
      dispatch(AddMenuHeadingAction({ heading: "Job Dashboard" }));
    } else {
      setJobPostFormMode("Card");
      setPostJobData(initialValues);
      setErrors({});
    }
  };
  const handleEdit = () => {
    setJobPostFormMode("Edit");
    setErrors({});
  };

  const handlePrimaryRecruiterLoading = () => {
    if (
      jobPostData?.ats_company_id !== "" ||
      jobPostData?.ats_grouporg_id !== "" ||
      jobPostData?.is_internal === true
    ) {
      const companyId = jobPostData?.ats_company_id?.ats_company_id
        || jobPostData?.ats_grouporg_id?.ats_grouporg_id
        || (isGroupOrgFlowTrue && userData?.user_type === "Group User" ? userData?.ats_grouporg_id : "Internal");
      GetAtsAllowedUsersHelper({
        company_id: companyId,
        consultancy_id: `{${jobPostData?.consultancy_id
          ?.map((row) => row?.consultancy_id)
          .join(",")}}`,
        recruiter_id: jobPostData?.secondary_recruiter_id?.recruiter_id || null,
      }).then((res) => {
        setPrimaryRecruiterData({ load: false, values: res?.data?.data });
      });
    } else setPrimaryRecruiterData({ load: false, values: [] });
  };
  const handleRecruiterManagerLoading = () => {
    if (
      jobPostData?.ats_company_id !== "" ||
      jobPostData?.ats_grouporg_id !== "" ||
      jobPostData?.is_internal === true
    ) {
      const companyId = jobPostData?.ats_company_id?.ats_company_id
        || jobPostData?.ats_grouporg_id?.ats_grouporg_id
        || (isGroupOrgFlowTrue && userData?.user_type === "Group User" ? userData?.ats_grouporg_id : "Internal");
      GetAtsAllowedUsersHelper({
        company_id: companyId,
        consultancy_id: `{}`,
        recruiter_id: jobPostData?.secondary_recruiter_id?.recruiter_id || null,
      }).then((res) => {
        setRecruiterManagerData({ load: false, values: res?.data?.data });
      });
    } else setRecruiterManagerData({ load: false, values: [] });
  };

  const handleSecondaryRecruiterLoading = () => {
    if (
      jobPostData?.ats_company_id !== "" ||
      jobPostData?.ats_grouporg_id !== "" ||
      jobPostData?.is_internal === true
    ) {
      const companyId = jobPostData?.ats_company_id?.ats_company_id
        || jobPostData?.ats_grouporg_id?.ats_grouporg_id
        || (isGroupOrgFlowTrue && userData?.user_type === "Group User" ? userData?.ats_grouporg_id : "Internal");
      GetAtsAllowedUsersHelper({
        company_id: companyId,
        consultancy_id: `{${jobPostData?.consultancy_id
          ?.map((row) => row?.consultancy_id)
          .join(",")}}`,
        recruiter_id: jobPostData?.primary_recruiter_id?.recruiter_id || null,
      }).then((res) => {
        const resData = res?.data?.data?.filter(el => el?.recruiter_id !== jobPostData?.primary_recruiter_id?.recruiter_id);
        setSecondaryRecruiterData({ load: false, values: resData });
      });
    } else setSecondaryRecruiterData({ load: false, values: [] });
  };

  const handleToggle = (e) => {
    if (e?.target?.checked === true) {
      setToggle(true);
      setPostJobData({
        ...jobPostData,
        [isGroupOrgFlowTrue ? 'ats_grouporg_id' : 'ats_company_id']: (isGroupOrgFlowTrue && userData?.user_type === "Group User") ? userData?.ats_grouporg_id : "Internal",
        primary_recruiter_id: [],
        secondary_recruiter_id: [],
        recruitment_manager_id: ""
      });
    } else {
      setToggle(false);
      setPostJobData({
        ...jobPostData,
        ats_grouporg_id: "",
        ats_company_id: "",
        primary_recruiter_id: [],
        secondary_recruiter_id: [],
        recruitment_manager_id: ""

      });
    }
    setPrimaryRecruiterData({ load: true, values: [] });
    setSecondaryRecruiterData({ load: true, values: [] });
    setRecruiterManagerData({ load: true, values: [] });
  };

  const toggleDrawer = (open, data, jobPostData) => {
    setAnchor(open);
    setDrawerdata(data);
    open && dispatch(GetJobTemplateAction({ job_title: data?.job_title, industry_code: data?.industry_code || jobPostData?.industry_type?.code }));
  };

  const handleIndustryTypeLoading = () => {
    GetIndustryTypeHelper().then((res) => {
      if (res?.data?.statuscode === 200)
        setIndustrytype({ load: false, values: res?.data?.data });
    });
  };

  const handleJobTemplateLoading = () => {
    jobPostData?.industry_type?.industry_type_id
      ? GetJobTemplateHelper({
        industry_code: jobPostData?.industry_type?.code,
      }).then((res) => {
        if (res?.data?.statuscode === 200 && res?.data?.data?.length > 0) {
          setJobTitle({ load: false, values: res?.data?.data });
        }
      })
      : setJobTitle({ load: false, values: [] });
  };
  const handleMPROption = () => {
    fnGetAvailableJobMprHelper({ats_jobpost_fk: null}).then((res) => {
      if (res?.data?.statuscode === 200) {
        const rawMprList = res?.data?.data?.[0]?.fn_get_available_job_mpr || [];
        const formattedList = rawMprList.map((item) => ({
          ...item,
          mpr_display: item?.hiring_type ? `${item.mpr_no} - ${item.hiring_type}` : item.mpr_no,
        }));
        setMprData({ load: false, values: formattedList });
      } else {
        setMprData({ load: false, values: [] });
      }
    })
  }
  const handleFeedBackTemplateLoading = () => {
    if (templateData?.values?.length > 0) {
      setFeedackTemplate({ load: false, values: templateData?.values });
    } else setFeedackTemplate({ load: false, values: [] });
  };

  const handlepreScreenTemplateLoading = (action, data) => {
    if (prescreenData?.length > 0) {
      setPrescreenTemplate({
        load: false,
        values: prescreenData,
      });
    } else setPrescreenTemplate({ load: false, values: [] });
    if (action === "new" && data?.length) {
      setPrescreenTemplate({ load: false, values: data });
    }
  };
  const handleOfferTemplateLoading = () => {
    if (offertemplateData?.values?.length > 0) {
      setOfferTemplate({ load: false, values: offertemplateData?.values });
    } else setOfferTemplate({ load: false, values: [] });
  };
  const handleBuload = () => {
    businessunitData && setBuOption({ load: false, values: businessunitData });
  };

  const handleApplyTemplate = (data) => {
    setAnchor(false);
    setRolesResponsibilities(data?.roles_responsibilities);
    setDescription(data?.description);
  };
  const handleATSSettings = () => {
    history.push({
      pathname: "/ats/ats-settings/",
      state: { defaultValue: "2" },
    });
  };
  const handleAddHiringPartner = () => {
    history.push({
      pathname: "/ats/manage-consultancy",
      state: { defaultValue: "add" },
    });
  };
  const handleAddClient = () => {
    history.push({
      pathname: "/ats/manage-company",
      state: { defaultValue: "add" },
    });
  };
  const handleAddGrp = () => {
    history.push({
      pathname: "/ats/manage-group-company",
      state: { defaultValue: "add" },
    });
  };
  const handleSkillsLoading = () => {
    jobPostData?.industry_type?.industry_type_id
      ? GetSkillsHelper({
        industry_code: jobPostData?.industry_type?.code,
      }).then((res) => {
        if (res?.data?.statuscode === 200 && res?.data?.data?.length > 0)
          setSkills({ load: false, values: res?.data?.data });
      })
      : setSkills({ load: false, values: [] });
  };
  const handleSkillsLoading2 = () => {
    jobPostData?.industry_type?.industry_type_id
      ? GetSkillsHelper({
        industry_code: jobPostData?.industry_type?.code,
      }).then((res) => {
        if (res?.data?.statuscode === 200 && res?.data?.data?.length > 0) {
          const selectedPrimaryskills = new Set(jobPostData?.primary_skill?.map(s => s.skill_id));
          const filteredSkills = res?.data?.data?.filter(skill => !selectedPrimaryskills?.has(skill?.skill_id));
          setSkills2({ load: false, values: filteredSkills });
        }
      })
      : setSkills2({ load: false, values: [] });
  };

  // create job using AI flow
    const aiConfigPopupRef = useRef();
    const { AiConfigLoading, ModelTestingLoading} = useSelector(
      (state) => state.AncillaryReducer?.AIConfigReducer
    );
    const { pythonJobCreationLoading } = useSelector(
        (state) => state.AtsReducer?.AtsProfileScoreReducer
      );
    // ai api key token validation
    useEffect(() => {
      if (aiConfigPopupRef.current && selectedOption === "ai") {
        aiConfigPopupRef.current.validateAIConfig();
      }
    },[selectedOption])
    const handleCloseModal = () => {
      handleClose();
      setModalOpen(false);
    };
  // AI or Manual seleciton Popup : Add Job
    const handleOptionSelect = (option) => {
      if (option === 'ai') {
        setSelectedOption(option);
      } else if (option === 'manual') {
        setSelectedOption(option);
      }
          setModalOpen(false);
    };

  // -------Add Job From MPR section----------
  // auto fill details from mpr data
    useEffect(() => {
      if (isAddJobFromMPR) {
        setModalOpen(false);
        setSelectedOption("manual");
        setDescription(mpr_data?.jd || "");
        setPostJobData((prev) => ({
        ...prev,
        businessunit_fk: mpr_data?.bu_id
          ? {
            businessunit_id: mpr_data?.bu_id,
            name: mpr_data?.bu_name,
          }
          : "",
        mpr_id: mpr_data?.mpr_requests_pk ? {
           ...mpr_data,
           mpr_id: mpr_data?.mpr_requests_pk, 
           mpr_no: mpr_data?.mpr_no,
           mpr_display: mpr_data?.hiring_type
            ? `${mpr_data.mpr_no} - ${mpr_data.hiring_type}`
            : mpr_data.mpr_no,
        } : "",
        approver_ats_users_id: mpr_data?.approver_id
          ? {
              ats_users_id: mpr_data?.approver_id,
              name: mpr_data?.approver_name,
            }
          : "",
        second_approver_ats_users_id: mpr_data?.second_approver_ats_users_id
          ? {
              ats_users_id: mpr_data?.second_approver_ats_users_id,
              name: mpr_data?.second_approver_emp_name,
            }
          : "",
        vaccancies: mpr_data?.approved_headcount,
        job_location: mpr_data?.location,
        min_salary: mpr_data?.min_salary || "",
        max_salary: mpr_data?.max_salary || "",
        min_exp_required: mpr_data?.min_experience || "",
        max_exp_required: mpr_data?.max_experience || "",
      }));
      }
      //eslint-disable-next-line
    },[location])
  return (
    <>
    {/* //dashboard is add job button and the edit and jobPostFormMode is undefined so no edit and preview */}
      {dashBoard ? (
        <Base>
          <>
          <AddJobSelectionModal
            open={modalOpen}
            onClose={handleCloseModal}
            onSelect={handleOptionSelect}
          />
            {candidatePreview === true ? (
              <AtsCandidateForm
                setCandidatePreview={setCandidatePreview}
                currentData={currentData}
                isProfile={true}
                editedRecord={editedRecord}
              />
            ) : (
              selectedOption === "ai" ? (
              <Box className={classes.mainContainer} >
                <Paper className={classes.PaperContainer}>
                  <Box className={classes.headerContainer}>
                    <Box>
                      <Typography className={classes.title}>AI Job Creation</Typography>
                      <Typography className={classes.subtitle}>
                        Provide basic details and let AI generate a professional job posting
                      </Typography>
                    </Box>
                    <Chip
                      icon={<AutoAwesomeIcon />}
                      label="AI POWERED"
                      size="small"
                      className={classes.aiBadge}
                    />
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column", position: "relative" }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={7}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          className={classes.fieldCard}
                        >
                          <AICreateJobFlowDetails
                            handleIndustryTypeLoading={handleIndustryTypeLoading}
                            industrytype={industrytype}
                            handleChange={handleChange}
                            errors={errors}
                            setErrors={setErrors}
                            handleJobTemplateLoading={handleJobTemplateLoading}
                            jobTitle={jobTitle}
                            handleSkillsLoading={handleSkillsLoading}
                            skills={skills}
                            handleSkillsLoading2={handleSkillsLoading2}
                            skills2={skills2}
                            jobPostData={jobPostData}
                            setPostJobData={setPostJobData}
                            setRolesResponsibilities={setRolesResponsibilities}
                            setDescription={setDescription}
                            setSelectedOption={setSelectedOption}
                          />
                        </Box>
                        {pythonJobCreationLoading && <AILineLoader />}
                      </Grid>
                      <Grid item xs={12} md={5}>
                        <Box className={classes.previewCardParent}>
                          <Box className={classes.previewCard}>
                              <Box className={classes.previewHeader}>
                                <WorkIcon color="primary" fontSize="small" />
                                <Typography variant="subtitle1" fontWeight={600}>
                                  Job Preview
                                </Typography>
                              </Box>
                              <JobInfoPreview jobPostData={jobPostData} />
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                    <AICongifWarningPopup ref={aiConfigPopupRef} validateFor="JD" />
                    <Backdrop className={classes.Backdrop} open={AiConfigLoading || ModelTestingLoading}>
                      <CircularProgress />
                    </Backdrop>
                  </Box>
                </Paper>
              </Box>
              ) : (
                <>
                  {/* // Add Job Button */}
                  <CreateJobStepper
                    jobPostFormMode={jobPostFormMode}
                    jobPostData={jobPostData}
                    setPostJobData={setPostJobData}
                    errors={errors}
                    setErrors={setErrors}
                    validate={validate}
                    handleChange={handleChange}
                    primaryRecruiterData={primaryRecruiterData}
                    atsCompanyData={atsCompanyData}
                    atsConsultancyData={atsConsultancyData}
                    companyData={companyData}
                    setCompanyData={setCompanyData}
                    atsgroupUser={atsgroupUser}
                    setAtsGroupUser={setAtsGroupUser}
                    consultancyData={consultancyData}
                    setConsultancyData={setConsultancyData}
                    jobTitle={jobTitle}
                    setJobTitle={setJobTitle}
                    industrytype={industrytype}
                    feedbackTemplate={feedbackTemplate}
                    prescreenTemplate={prescreenTemplate}
                    offerTemplate={offerTemplate}
                    offerstatus={offerstatus}
                    skills={skills}
                    setSkills={setSkills}
                    handleSkillsLoading2={handleSkillsLoading2}
                    setSkills2={setSkills2}
                    skills2={skills2}
                    rolesresponsibilities={rolesresponsibilities}
                    setRolesResponsibilities={setRolesResponsibilities}
                    description={description}
                    setDescription={setDescription}
                    handlePrimaryRecruiterLoading={handlePrimaryRecruiterLoading}
                    handleToggle={handleToggle}
                    handleIndustryTypeLoading={handleIndustryTypeLoading}
                    handleJobTemplateLoading={handleJobTemplateLoading}
                    handleFeedBackTemplateLoading={handleFeedBackTemplateLoading}
                    handlepreScreenTemplateLoading={handlepreScreenTemplateLoading}
                    handleOfferTemplateLoading={handleOfferTemplateLoading}
                    handleSkillsLoading={handleSkillsLoading}
                    handleClose={handleClose}
                    toggle={toggle}
                    isGroupOrgFlowTrue={isGroupOrgFlowTrue}
                    prebuilderTitle={prebuilderTitle}
                    setPreBuilderTitle={setPreBuilderTitle}
                    handleSubmit={handleSubmit}
                    populateDefaultPreScreeningTemplate={populateDefaultPreScreeningTemplate}
                    handleRecruiterManagerLoading={handleRecruiterManagerLoading}
                    recruiterManagerData={recruiterManagerData}
                    handleMPROption={handleMPROption}
                    mprData={mprData}
                    handleBuload={handleBuload}
                    buOption={buOption}
                    handleApproverList={handleApproverList}
                    approverListData={approverListData}
                  />

                </>
              )
            )}
            {
              <AtsJobTemplatePreview
                anchor={anchor}
                toggleDrawer={toggleDrawer}
                drawerdata={drawerdata}
                handleApplyTemplate={handleApplyTemplate}
                jobPostData={jobPostData}
                setPostJobData={setPostJobData}
              />
            }

            {jobPostFormMode === "Preview" && (
              <ConfirmationDialog
                title="Propose Candidate"
                content={`Do you wish to Propose ${data?.first_name} to ${editedRecord.title}?`}
                anchorE={anchorE}
                openDialog={openDialog}
                closeDialog={setOpenDialog}
                popupTitle="Job"
                OkButtonText="Yes Propose"
                onSubmit={handleConfirmPropose}
              />
            )}
            <Popup
              title={"Feed Back Template"}
              openPopup={formBuilder}
              setOpenPopup={setFormBuilder}
              maxWidth="md"
              fullWidth={true}
            >
              <FormBuilder
                formBuilder={formBuilder}
                setFormBuilder={setFormBuilder}
                JD={true}
                title={builderTitle}
              />
            </Popup>
            {/* prescreen template builder popup */}
            <Popup
                title={"Pre-Screen Assessment Template"}
                openPopup={preformBuilder}
                setOpenPopup={setPreFormBuilder}
                maxWidth="md"
                fullWidth={true}
              >
                <PreScreen
                  preformBuilder={preformBuilder}
                  setPreFormBuilder={setPreFormBuilder}
                  JD={true}
                  title={prebuilderTitle}
                  setPostJobData={setPostJobData}
                  setPreBuilderTitle={setPreBuilderTitle}
                  handlepreScreenTemplateLoading={handlepreScreenTemplateLoading}
                />
            </Popup>
          </>{" "}
        </Base>
      ) : (
        <>
          {candidatePreview === true ? (
            <AtsCandidateForm
              setCandidatePreview={setCandidatePreview}
              currentData={currentData}
              isProfile={true}
              editedRecord={editedRecord}
            />
          ) : (
            <>
            {/* //Job Dashboard: Job Preview and Edit  */}
              <Box sx={{width:isMobile ? "100%" : !fixedMenu && !open ? "calc(100vw - 75px)" : "calc(100vw - 255px)", maxHeight: "90vh", overflowY: "auto", pb: 2}}>
                <Box
                  sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    backgroundColor: "#ffffff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    p: 2,
                  }}
                >
                  <ArrowBackButton onClick={handleClose} />
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      sx={{
                        fontFamily: "Nunito Sans",
                        fontWeight: 700,
                        color: "#000000",
                        fontSize: "large",
                      }}
                    >
                      {jobPostFormMode === "Preview"
                        ? "Preview Job"
                        : jobPostFormMode === "Edit"
                          ? "Update Job"
                          : "Create New Job"}
                    </Typography>
                    {jobPostData?.is_ai_job && (
                      <Chip
                        icon={<AutoAwesomeIcon />}
                        label="AI POWERED"
                        size="small"
                        className={"ai-mpl-btn"}
                        sx={{"& .MuiChip-icon": {
                          color: "white",
                          },
                        }}
                      />
                    )}
                  </Box>
                  {jobPostFormMode === "Preview" && (
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                      {canEdit && (
                        <Button
                          variant="contained"
                          className="mpl-primary-btn"
                          onClick={handleEdit}
                        >
                          Edit
                        </Button>
                      )}
                    </Box>
                  )}

                  {jobPostFormMode !== "Preview" && (
                    <Button
                      sx={{ ml: 1 }}
                      variant="contained"
                      className="mpl-primary-btn"
                      onClick={() => {
                        handleSubmit();
                      }}
                    >
                      {jobPostData?.ats_jobpost_id ? "Update" : "Save"}
                    </Button>
                  )}
                </Box>
                <Paper sx={{ borderRadius: "10px", p: 1.5, overflowY: "auto" }}>
                  {jobPostFormMode !== "Preview" && (
                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        {["Admin", "Owner", "Internal"].includes(userData?.user_type) && (
                          <>
                            <div style={{ display: "flex" }}>
                              {userData?.user_type !== "Internal" && (
                                <>
                                  <div style={{ display: "flex", marginRight: "8px" }}>
                                    <Typography>
                                      *To review your industry sectors/ job titles/ skills{" "}
                                      <span
                                        style={{ color: "#1155cc", cursor: "pointer", textDecoration: "underline" }}
                                        onClick={handleATSSettings}
                                      >
                                        Click Here
                                      </span>
                                    </Typography>
                                  </div>
                                  <div style={{ display: "flex", marginRight: "8px" }}>
                                    <Typography>
                                      *To add Hiring Partners{" "}
                                      <span
                                        style={{ color: "#1155cc", cursor: "pointer", textDecoration: "underline" }}
                                        onClick={handleAddHiringPartner}
                                      >
                                        Click Here
                                      </span>
                                    </Typography>
                                  </div>
                                  {toggle === false && (
                                    <>
                                      {isGroupOrgFlowTrue ? (
                                        <div style={{ display: "flex" }}>
                                          <Typography>
                                            *To add a Group Org{" "}
                                            <span
                                              style={{ color: "#1155cc", cursor: "pointer", textDecoration: "underline" }}
                                              onClick={handleAddGrp}
                                            >
                                              Click Here
                                            </span>
                                          </Typography>
                                        </div>
                                      ) : (
                                        <div style={{ display: "flex" }}>
                                          <Typography>
                                            *To add a Client{" "}
                                            <span
                                              style={{ color: "#1155cc", cursor: "pointer", textDecoration: "underline" }}
                                              onClick={handleAddClient}
                                            >
                                              Click Here
                                            </span>
                                          </Typography>
                                        </div>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </div>

                            <div>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      onChange={handleToggle}
                                      checked={toggle}
                                      disabled={["Edit", "Preview"].includes(jobPostFormMode)}
                                    />
                                  }
                                  label="is internal job"
                                />
                              </FormGroup>
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  )}
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12}>
                        <Card>
                          <CardContent>
                            <Grid container sx={{ mt: 1 }}>
                              {!toggle && (
                              <Grid item xs={12} md={4} sx={{ p: 1 }}>                  
                                  <>
                                    {isGroupOrgFlowTrue ? (

                                      <SelectableSearch
                                        isOptionEqualToValue={(option, value) =>
                                          +option.ats_grouporg_id ===
                                          +value.ats_grouporg_id
                                        }
                                        disabled={jobPostFormMode === "Preview"}
                                        customBackground
                                        label="Group Org"
                                        value={jobPostData?.ats_grouporg_id}
                                        loading={() =>
                                          setAtsGroupUser({
                                            load: false,
                                            values: atsGroupCompanyData,
                                          })
                                        }
                                        fieldLabel="name"
                                        required
                                        variant={"contained"}
                                        name="ats_grouporg_id"
                                        size="small"
                                        data={atsgroupUser}
                                        onChangeEvent={handleChange}
                                        {...(errors.ats_grouporg_id && {
                                          error: true,
                                          helperText: errors.ats_grouporg_id,
                                        })}
                                      />
                                    ) : (
                                      <SelectableSearch
                                        isOptionEqualToValue={(option, value) =>
                                          +option.ats_company_id ===
                                          +value.ats_company_id
                                        }
                                        disabled={jobPostFormMode === "Preview"}
                                        customBackground
                                        label="Client"
                                        value={jobPostData?.ats_company_id}
                                        loading={() =>
                                          setCompanyData({
                                            load: false,
                                            values: atsCompanyData,
                                          })
                                        }
                                        fieldLabel="company"
                                        required
                                        variant={"contained"}
                                        name="ats_company_id"
                                        size="small"
                                        data={companyData}
                                        onChangeEvent={handleChange}
                                        {...(errors.ats_company_id && {
                                          error: true,
                                          helperText: errors.ats_company_id,
                                        })}
                                      />
                                    )}
                                  </>
                              </Grid>)}
                              <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                {userData?.user_type === "Consultancy" ? (
                                  <TextField
                                    disabled={true}
                                    name="consultancy_id"
                                    label="Hiring Partner"
                                    size="small"
                                    fullWidth
                                    variant="outlined"
                                    value={atsConsultancyData?.[0]?.consultancy}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                ) : (
                                  <SelectableSearch
                                    isOptionEqualToValue={(option, value) =>
                                      +option.consultancy_id ===
                                      +value.consultancy_id
                                    }
                                    disabled={jobPostFormMode === "Preview"}
                                    customBackground
                                    label="Hiring Partner"
                                    value={jobPostData?.consultancy_id}
                                    loading={() =>
                                      setConsultancyData({
                                        load: false,
                                        values: atsConsultancyData,
                                      })
                                    }
                                    fieldLabel="consultancy"
                                    required={false}
                                    limitTags={2}
                                    multiple={true}
                                    variant={"contained"}
                                    name="consultancy_id"
                                    size="small"
                                    data={consultancyData}
                                    onChangeEvent={handleChange}
                                    {...(errors.consultancy_id && {
                                      error: true,
                                      helperText: errors.consultancy_id,
                                    })}
                                  />
                                )}
                              </Grid>
                              <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                <SelectableSearch
                                  isOptionEqualToValue={(option, value) =>
                                    +option.recruiter_id === +value.recruiter_id
                                  }
                                  disabled={jobPostFormMode === "Preview"}
                                  customBackground
                                  required={true}
                                  label="Primary Recruiter"
                                  noOptionText="Please select client to choose recruiter"
                                  value={jobPostData?.primary_recruiter_id}
                                  loading={() =>
                                    handlePrimaryRecruiterLoading()
                                  }
                                  fieldLabel="recruiter"
                                  variant={"contained"}
                                  name="primary_recruiter_id"
                                  size="small"
                                  data={primaryRecruiterData}
                                  onChangeEvent={handleChange}
                                  {...(errors.primary_recruiter_id && {
                                    error: true,
                                    helperText: errors.primary_recruiter_id,
                                  })}
                                  renderOption={(props, option) => (
                                    <Box
                                      component="li"
                                      sx={{
                                        "& > img": { mr: 2, flexShrink: 0 },
                                      }}
                                      {...props}
                                    >
                                      {option?.recruiter} -{" "}
                                      {option?.comcons_name
                                        ? option?.comcons_name
                                        : option?.user_type}
                                    </Box>
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                <SelectableSearch
                                  isOptionEqualToValue={(option, value) =>
                                    +option.recruiter_id === +value.recruiter_id
                                  }
                                  disabled={jobPostFormMode === "Preview"}
                                  required={true}
                                  label="Recruitment Manager"
                                  noOptionText="Please select primary recruiter to choose recruitment manager"
                                  value={jobPostData?.recruitment_manager_id}
                                  loading={() => handleRecruiterManagerLoading()}
                                  fieldLabel="recruiter"
                                  variant={"contained"}
                                  customBackground
                                  name="recruitment_manager_id"
                                  size="small"
                                  data={recruiterManagerData}
                                  onChangeEvent={handleChange}
                                  {...(errors.recruitment_manager_id && {
                                    error: true,
                                    helperText: errors.recruitment_manager_id,
                                  })}
                                  renderOption={(props, option) => (
                                    <Box
                                      component="li"
                                      sx={{
                                        "& > img": { mr: 2, flexShrink: 0 },
                                      }}
                                      {...props}
                                    >
                                      {option?.recruiter} -{" "}
                                      {option?.comcons_name
                                        ? option?.comcons_name
                                        : option?.user_type}
                                    </Box>
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                <CreatableSearch
                                  isOptionEqualToValue={(option, value) =>
                                    +option.industry_name ===
                                    +value.industry_name
                                  }
                                  disabled={jobPostFormMode === "Preview"}
                                  customBackground
                                  label="Industry Sector"
                                  value={jobPostData?.industry_type}
                                  fieldLabel="industry_name"
                                  loading={() => handleIndustryTypeLoading()}
                                  required={true}
                                  variant={"contained"}
                                  noOptionText="Start typing to add or select industry"
                                  name="industry_type"
                                  size="small"
                                  data={industrytype}
                                  onChangeEvent={handleChange}
                                  {...(errors.industry_type && {
                                    error: true,
                                    helperText: errors.industry_type,
                                  })}
                                />
                              </Grid>
                              <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                <CreatableSearch
                                  isOptionEqualToValue={(option, value) =>
                                    +option.job_template_id ===
                                    +value.job_template_id
                                  }
                                  disabled={jobPostFormMode === "Preview"}
                                  customBackground
                                  label="Job Title"
                                  value={jobPostData?.title}
                                  noOptionText="Please select Industry Sector to choose title"
                                  fieldLabel="job_title"
                                  loading={() => handleJobTemplateLoading()}
                                  required={true}
                                  variant={"contained"}
                                  name="title"
                                  size="small"
                                  data={jobTitle}
                                  onChangeEvent={handleChange}
                                  {...(errors.title && {
                                    error: true,
                                    helperText: errors.title,
                                  })}
                                />
                              </Grid>
                              {/* MPR */}
                              <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                <Tooltip
                                  title={
                                   !(jobPostFormMode === "Preview") && jobPostData?.mpr_id?.is_utilised
                                      ? "MPR cannot be changed once a candidate is proposed against it."
                                      : ""
                                  }
                                  arrow
                                  placement="top"
                                >
                                  <div>
                                    <SelectableSearch
                                      isOptionEqualToValue={(option, value) =>
                                        +option.mpr_id === +value.mpr_id
                                      }
                                      disabled={jobPostFormMode === "Preview" || isMprLoading || jobPostData?.mpr_id?.is_utilised}
                                      customBackground
                                      label="MPR"
                                      required={false}
                                      value={
                                        jobPostData?.mpr_id
                                          ? {
                                              ...jobPostData.mpr_id,
                                              mpr_display:
                                                jobPostData.mpr_id?.mpr_display ||
                                                (jobPostData.mpr_id?.hiring_type
                                                  ? `${jobPostData.mpr_id.mpr_no} - ${jobPostData.mpr_id.hiring_type}`
                                                  : jobPostData.mpr_id.mpr_no),
                                            }
                                          : null
                                      }
                                      loading={() => handleMPROption()}
                                      fieldLabel="mpr_display"
                                      variant={"contained"}
                                      name="mpr_id"
                                      size="small"
                                      data={mprData}
                                      onChangeEvent={handleMPRChange}
                                      optionsTooltipKeys={[
                                        { key: "role", prefix: "Designation: " },
                                        { key: "is_budgeted", prefix: "Is Budgeted: " },
                                        { key: "max_salary", prefix: "Max Salary: " },
                                      ]}
                                      {...(errors.mpr_id && {
                                        error: true,
                                        helperText: errors.mpr_id,
                                      })}
                                    />
                                  </div>
                                 </Tooltip>
                              </Grid>
                              <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                <SelectableSearch
                                  isOptionEqualToValue={(option, value) =>
                                    +option.businessunit_id === +value.businessunit_id
                                  }
                                  disabled={jobPostFormMode === "Preview"}
                                  customBackground
                                  label="Department"
                                  value={jobPostData?.businessunit_fk}
                                  loading={() => handleBuload()}
                                  fieldLabel="name"
                                  name="businessunit_fk"
                                  size="small"
                                  onChangeEvent={handleChange}
                                  data={buOption}
                                  {...(errors?.businessunit_fk && {
                                    error: true,
                                    helperText: errors?.businessunit_fk,
                                  })}
                                />
                              </Grid>
                              <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                <CreatableSearch
                                  isOptionEqualToValue={(option, value) =>
                                    option.skill === value.skill
                                  }
                                  disabled={jobPostFormMode === "Preview"}
                                  customBackground
                                  label="Primary Skills Required"
                                  value={jobPostData?.primary_skill}
                                  fieldLabel="skill"
                                  loading={() =>
                                    jobPostData?.industry_type?.industry_type_id
                                      ? handleSkillsLoading()
                                      : setSkills({ load: false, values: [] })
                                  }
                                  required={true}
                                  limitTags={2}
                                  noOptionText="Please select Industry Sector to choose skills"
                                  variant={"contained"}
                                  name="primary_skill"
                                  size="small"
                                  optionLabel="skill"
                                  multiple={true}
                                  data={skills}
                                  onChangeEvent={handleChange}
                                  {...(errors.primary_skill && {
                                    error: true,
                                    helperText: errors.primary_skill,
                                  })}
                                />
                              </Grid>
                              <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                <CustomTextField
                                  disabled={jobPostFormMode === "Preview"}
                                  name="vaccancies"
                                  label="Number of vacancies"
                                  size="small"
                                  type="number"
                                  onKeyPress={(e) =>
                                    e.target.value?.length > 4 &&
                                    e.preventDefault()
                                  }
                                  onPaste={(e) =>
                                    e.target.value?.length > 4 &&
                                    e.preventDefault()
                                  }
                                  required={true}
                                  onChange={handleChange}
                                  fullWidth
                                  variant="outlined"
                                  value={jobPostData.vaccancies}
                                  {...(errors.vaccancies && {
                                    error: true,
                                    helperText: errors.vaccancies,
                                  })}
                                />
                              </Grid>
                              <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                <CustomTextField
                                  disabled={jobPostFormMode === "Preview"}
                                  name="job_location"
                                  label="Job Location"
                                  size="small"
                                  required={true}
                                  onChange={handleChange}
                                  onKeyPress={(e) =>
                                    e.target.value?.length > 100 &&
                                    e.preventDefault()
                                  }
                                  onPaste={(e) =>
                                    e.target.value?.length > 100 &&
                                    e.preventDefault()
                                  }
                                  fullWidth
                                  variant="outlined"
                                  value={jobPostData.job_location}
                                  {...(errors?.job_location && {
                                    error: true,
                                    helperText: errors?.job_location,
                                  })}
                                />
                              </Grid>
                              <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                <CreatableSearch
                                  isOptionEqualToValue={(option, value) =>
                                    +option.template_id === +value.template_id
                                  }
                                  disabled={jobPostFormMode === "Preview"}
                                  customBackground
                                  label="Feedback Template"
                                  name="feedback_template_id"
                                  value={jobPostData?.feedback_template_id}
                                  loading={handleFeedBackTemplateLoading}
                                  fieldLabel="template_name"
                                  variant={"contained"}
                                  size="small"
                                  data={feedbackTemplate}
                                  onChangeEvent={handleChange}
                                  {...(errors.feedback_template_id && {
                                    error: true,
                                    helperText: errors.feedback_template_id,
                                  })}
                                />
                              </Grid>
                              {jobPostData?.is_ai_job ? (
                                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                  <CustomTextField
                                      fullWidth
                                      size="small"
                                      label="Pre-Screen Assessment Template"
                                      disabled={jobPostFormMode === "Preview"}
                                      value={
                                        jobPostData?.prescreen_template_id?.prescreen_template_name ? "Custom Template" : ""
                                      }
                                      placeholder="Click to view or edit screening questions"
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                      onClick={() => setEditDialogOpen(true)}
                                      sx={{
                                        cursor: "pointer",
                                        "& .MuiOutlinedInput-root": {
                                          cursor: "pointer",
                                        },
                                      }}
                                    />
                                </Grid>
                                ) : (
                                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                  <CreatableSearch
                                    isOptionEqualToValue={(option, value) =>
                                      +option.prescreen_template_id ===
                                      +value.prescreen_template_id
                                    }
                                    disabled={jobPostFormMode === "Preview"}
                                    customBackground
                                    label="Pre-Screen Assessment Template"
                                    name="prescreen_template_id"
                                    value={jobPostData?.prescreen_template_id}
                                    loading={() =>
                                      handlepreScreenTemplateLoading()
                                    }
                                    fieldLabel="prescreen_template_name"
                                    variant={"contained"}
                                    size="small"
                                    data={prescreenTemplate}
                                    onChangeEvent={handleChange}
                                    {...(errors.prescreen_template_id && {
                                      error: true,
                                      helperText: errors.prescreen_template_id,
                                    })}
                                  />
                                </Grid>
                              )}
                            <Grid
                              container
                              item
                              xs={12}
                              alignItems="center"
                              sx={{
                                ...(jobPostData?.offer_letter && {
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "5px",
                                  pt: "2px",
                                  mx: 1
                                }),
                              }}
                            >
                              <Grid
                                item
                                xs={12}
                                md={3}
                                sx={{
                                  p: 1,
                                  display: "flex",
                                  alignItems: "center",
                                  pl: 1
                                }}
                              >
                                <FormControl
                                  disabled={
                                    jobPostFormMode === "Preview" ||
                                    jobPostFormMode === "Edit" ||
                                    Boolean(offerstatus)
                                  }
                                >
                                  <FormLabel
                                    id="demo-row-radio-buttons-group-label"
                                    sx={{ mr: 2 }}
                                    className={classes.labelText2}
                                  >
                                    Include offer letter work flow?
                                  </FormLabel>
                                  <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="offer_letter"
                                    onChange={handleChange}
                                    value={jobPostData?.offer_letter}
                                    sx={{ mt: -1, height: "32px" }}
                                  >
                                    <FormControlLabel
                                      value={true}
                                      control={<Radio size="small" />}
                                      label="Yes"
                                    />
                                    <FormControlLabel
                                      value={false}
                                      control={<Radio size="small" />}
                                      label="No"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </Grid>
                              {jobPostData?.offer_letter && (
                                <Grid item xs={12} md={3} sx={{ p: 1 }}>
                                <SelectableSearch
                                  isOptionEqualToValue={(option, value) =>
                                    +option.offer_letter_template_id ===
                                    +value.offer_letter_template_id
                                  }
                                  required
                                  disabled={
                                    jobPostFormMode === "Preview" ||
                                    Boolean(offerstatus) ||
                                    !jobPostData?.offer_letter
                                  }
                                  customBackground
                                  label="Offer Letter Template"
                                  name="offer_letter_template_id"
                                  value={
                                    jobPostData?.offer_letter_template_id
                                  }
                                  loading={() => handleOfferTemplateLoading()}
                                  endIcon={
                                    (() => {
                                      const selected = (offertemplateData?.values || offerTemplate?.values || []).find(
                                        (t) => +t.offer_letter_template_id === +(jobPostData?.offer_letter_template_id?.offer_letter_template_id || jobPostData?.offer_letter_template_id)
                                      );
                                      if (!selected) return null;
                                      return (
                                        <Tooltip
                                          title={
                                            <Box sx={{ fontSize: "12px", lineHeight: 1.5 }}>
                                              <Box>• {(selected?.is_letterhead === true || selected?.header_footer_mode === "LETTERHEAD")
                                                ? "Uses pre-uploaded official company letterhead PDF document background"
                                                : "Uses company logo, header title, and footer text configured in settings"}</Box>
                                              <Box>• {selected?.is_configure_ctc === false ? "CTC is not configured" : "CTC is configured"}</Box>
                                            </Box>
                                          }
                                          arrow
                                          placement="top"
                                        >
                                          <InfoOutlinedIcon sx={{ fontSize: 18, cursor: "pointer", color: "text.secondary" }} />
                                        </Tooltip>
                                      );
                                    })()
                                  }
                                  fieldLabel="offer_letter_template_name"
                                  variant={"contained"}
                                  size="small"
                                  data={offerTemplate}
                                  onChangeEvent={handleChange}
                                  optionsTooltipKeys={[
                                    { key: "template_type", prefix: "Type: " },
                                    { key: "ctc_status", prefix: "CTC: " },
                                  ]}
                                  {...(errors.offer_letter_template_id && {
                                    error: true,
                                    helperText:
                                      errors.offer_letter_template_id,
                                  })}
                                />
                              </Grid>)}
                              {jobPostData?.offer_letter && (
                                <>
                              <Grid item xs={12} md={3} sx={{ p: 1 }}>
                                <SelectableSearch
                                  isOptionEqualToValue={(option, value) =>
                                    +option.ats_users_id === +value.ats_users_id
                                  }
                                  disabled={
                                    jobPostFormMode === "Preview" ||
                                    Boolean(offerstatus) ||
                                    !jobPostData?.offer_letter
                                  }
                                  required={jobPostData?.offer_letter}
                                  customBackground
                                  label="Primary Approver"
                                  name="approver_ats_users_id"
                                  value={jobPostData?.approver_ats_users_id}
                                  loading={() => handleApproverList("approver")}
                                  fieldLabel="name"
                                  variant={"contained"}
                                  size="small"
                                  data={approverListData}
                                  onChangeEvent={handleChange}
                                  {...(errors.approver_ats_users_id && {
                                    error: true,
                                    helperText: errors.approver_ats_users_id,
                                  })}
                                  endIcon={
                                    <Tooltip title="Primary approver for this job. Approval is required when Offer Letter Flow is enabled. The candidate's CTC is compared against the MPR's max salary if the MPR is budgeted; otherwise, the Job's Max Salary is used. If neither limit is available, secondary approval is not required. Cannot be changed once the offer is generated." placement="top" arrow> 
                                        <InfoOutlinedIcon sx={{ fontSize: 18, cursor: "pointer", color: "text.secondary"}}/>
                                    </Tooltip>
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} md={3} sx={{ p: 1 }}>
                                <SelectableSearch
                                  isOptionEqualToValue={(option, value) =>
                                    +option.ats_users_id === +value.ats_users_id
                                  }
                                  disabled={
                                    jobPostFormMode === "Preview" ||
                                    Boolean(offerstatus) ||
                                    !jobPostData?.offer_letter
                                  }
                                  required={jobPostData?.offer_letter}
                                  customBackground
                                  label="Secondary Approver"
                                  name="second_approver_ats_users_id"
                                  value={jobPostData?.second_approver_ats_users_id}
                                  loading={() => handleApproverList("second_approver")}
                                  fieldLabel="name"
                                  variant={"contained"}
                                  size="small"
                                  data={approverListData}
                                  onChangeEvent={handleChange}
                                  {...(errors.second_approver_ats_users_id && {
                                    error: true,
                                    helperText:
                                      errors.second_approver_ats_users_id,
                                  })}
                                  endIcon={
                                    <Tooltip title="Secondary approver for this job. Required after Primary Approval if the candidate's CTC exceeds the applicable maximum limit (MPR's max salary for budgeted MPRs, or Job's Max Salary otherwise). If no applicable maximum limit is available, secondary approval is not required. Cannot be changed once the offer is generated." placement="top" arrow>
                                      <InfoOutlinedIcon sx={{ fontSize: 18, cursor: "pointer", color: "text.secondary"}}/>
                                    </Tooltip>
                                  }
                                />
                              </Grid>
                              </>
                            )}
                          </Grid>
                            
                              <Grid container sx={{ mt: 1 }}>
                                {/* <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                                            <TextField
                                                                disabled={jobPostFormMode === "Preview"}
                                                                name='job_position'
                                                                label="Job Position"
                                                                size='small'
                                                                onChange={handleChange}
                                                                onKeyPress={(e) => e.target.value?.length > 100 && e.preventDefault()}
                                                                onPaste={(e) => e.target.value?.length > 100 && e.preventDefault()}
                                                                fullWidth
                                                                variant="outlined"
                                                                value={jobPostData.job_position}
                                                                {...(errors.job_position && {
                                                                    error: true,
                                                                    helperText: errors.job_position,
                                                                })}
                                                            />
                                                        </Grid> */}
                                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                  <CustomTextField
                                    disabled={jobPostFormMode === "Preview"}
                                    name="designation"
                                    label="Designation"
                                    size="small"
                                    onChange={handleChange}
                                    onKeyPress={(e) =>
                                      e.target.value?.length > 100 && e.preventDefault()
                                    }
                                    onPaste={(e) =>
                                      e.target.value?.length > 100 && e.preventDefault()
                                    }
                                    fullWidth
                                    variant="outlined"
                                    value={jobPostData.designation}
                                    {...(errors?.designation && {
                                      error: true,
                                      helperText: errors?.designation,
                                    })}
                                  />
                                </Grid>
                                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                  <SelectableSearch
                                    isOptionEqualToValue={(option, value) =>
                                      +option.recruiter_id ===
                                      +value.recruiter_id
                                    }
                                    multiple={true}
                                    disabled={jobPostFormMode === "Preview"}
                                    customBackground
                                    label="Secondary Recruiter"
                                    value={jobPostData?.secondary_recruiter_id}
                                    loading={() =>
                                      handleSecondaryRecruiterLoading()
                                    }
                                    fieldLabel="recruiter"
                                    noOptionText="Please select client to choose recruiter"
                                    variant={"contained"}
                                    name="secondary_recruiter_id"
                                    size="small"
                                    data={secondaryRecruiterData}
                                    onChangeEvent={handleChange}
                                    {...(errors.secondary_recruiter_id && {
                                      error: true,
                                      helperText: errors.secondary_recruiter_id,
                                    })}
                                    renderOption={(props, option) => (
                                      <Box
                                        component="li"
                                        sx={{
                                          "& > img": { mr: 2, flexShrink: 0 },
                                        }}
                                        {...props}
                                      >
                                        {option?.recruiter} -{" "}
                                        {option?.comcons_name
                                          ? option?.comcons_name
                                          : option?.user_type}
                                      </Box>
                                    )}
                                  />
                                </Grid>
                                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                  <CreatableSearch
                                    isOptionEqualToValue={(option, value) =>
                                      option.skill === value.skill
                                    }
                                    disabled={jobPostFormMode === "Preview"}
                                    customBackground
                                    label="Secondary Skills Required"
                                    value={jobPostData?.secondary_skill}
                                    fieldLabel="skill"
                                    noOptionText="Please select Industry Sector to choose skills"
                                    optionLabel="skill"
                                    multiple={true}
                                    loading={() =>
                                      jobPostData?.industry_type
                                        ?.industry_type_id
                                        ? handleSkillsLoading2()
                                        : setSkills2({ load: false, values: [] })
                                    }
                                    variant={"contained"}
                                    name="secondary_skill"
                                    size="small"
                                    data={skills2}
                                    onChangeEvent={handleChange}
                                    {...(errors.secondary_skill && {
                                      error: true,
                                      helperText: errors.secondary_skill,
                                    })}
                                  />
                                </Grid>
                                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                  <CustomTextField
                                    disabled={jobPostFormMode === "Preview"}
                                    name="preferred_qualification"
                                    label="Preferred Qualification"
                                    size="small"
                                    onKeyPress={(e) =>
                                      e.target.value?.length > 254 &&
                                      e.preventDefault()
                                    }
                                    onPaste={(e) =>
                                      e.target.value?.length > 254 &&
                                      e.preventDefault()
                                    }
                                    onChange={handleChange}
                                    fullWidth
                                    variant="outlined"
                                    value={jobPostData.preferred_qualification}
                                  />
                                </Grid>
                                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                  <CustomTextField
                                    disabled={jobPostFormMode === "Preview"}
                                    name="min_exp_required"
                                    label="Minimum Experience"
                                    size="small"
                                    type="number"
                                    onKeyPress={(e) =>
                                      e.target.value?.length > 2 &&
                                      e.preventDefault()
                                    }
                                    onPaste={(e) =>
                                      e.target.value?.length > 2 &&
                                      e.preventDefault()
                                    }
                                    onChange={handleChange}
                                    fullWidth
                                    variant="outlined"
                                    value={jobPostData.min_exp_required}
                                    {...(errors.min_exp_required && {
                                      error: true,
                                      helperText: errors.min_exp_required,
                                    })}
                                  />
                                </Grid>
                                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                  <CustomTextField
                                    disabled={jobPostFormMode === "Preview"}
                                    name="max_exp_required"
                                    label="Maximum Experience"
                                    size="small"
                                    type="number"
                                    onChange={handleChange}
                                    onKeyPress={(e) =>
                                      e.target.value?.length > 2 &&
                                      e.preventDefault()
                                    }
                                    onPaste={(e) =>
                                      e.target.value?.length > 2 &&
                                      e.preventDefault()
                                    }
                                    fullWidth
                                    variant="outlined"
                                    value={jobPostData.max_exp_required}
                                  />
                                </Grid>
                                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                  <CustomTextField
                                    disabled={jobPostFormMode === "Preview"}
                                    name="min_salary"
                                    label="Minimum Salary"
                                    size="small"
                                    required
                                    type="number"
                                    onChange={handleChange}
                                    fullWidth
                                    variant="outlined"
                                    onKeyPress={(e) =>
                                      e.target.value?.length > 10 &&
                                      e.preventDefault()
                                    }
                                    onPaste={(e) =>
                                      e.target.value?.length > 10 &&
                                      e.preventDefault()
                                    }
                                    value={jobPostData.min_salary}
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <Tooltip title="Minimum CTC to hire">
                                            <InfoOutlinedIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                                          </Tooltip>
                                        </InputAdornment>
                                      ),
                                    }}
                                    {...(errors.min_salary && {
                                      error: true,
                                      helperText: errors.min_salary,
                                    })}
                                  />
                                </Grid>
                                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                  <CustomTextField
                                    required={jobPostData?.offer_letter && (!jobPostData?.mpr_id || !jobPostData?.mpr_id?.is_budgeted)} // when mpr is not mapped/ non budgeted then Offer/CTC approval check job max salary
                                    disabled={jobPostFormMode === "Preview"}
                                    name="max_salary"
                                    label="Maximum Salary"
                                    size="small"
                                    type="number"
                                    onKeyPress={(e) =>
                                      e.target.value?.length > 10 &&
                                      e.preventDefault()
                                    }
                                    onPaste={(e) =>
                                      e.target.value?.length > 10 &&
                                      e.preventDefault()
                                    }
                                    onChange={handleChange}
                                    fullWidth
                                    variant="outlined"
                                    value={jobPostData?.max_salary}
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <Tooltip title="Maximum CTC to hire">
                                            <InfoOutlinedIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                                          </Tooltip>
                                        </InputAdornment>
                                      ),
                                    }}
                                    {...(errors.max_salary && {
                                      error: true,
                                      helperText: errors.max_salary,
                                    })}
                                  />
                                </Grid>
                                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                  <FormControl
                                    fullWidth
                                    error={errors?.priority ? true : false}
                                    size="small"
                                    disabled={jobPostFormMode === "Preview"}
                                  >
                                    <InputLabel id="recruiter-type-select-label">
                                      Severity
                                    </InputLabel>
                                    <Select
                                      name="priority"
                                      labelId="recruiter-type-select-label"
                                      id="recruiter-type-select"
                                      value={jobPostData?.priority}
                                      label="Severity"
                                      onChange={handleChange}
                                      sx={{
                                        backgroundColor: "#ffffff",
                                        "&.Mui-disabled": {
                                          backgroundColor: "inherit",
                                        }
                                      }}
                                    >
                                      <MenuItem value={"Low"}>Low</MenuItem>
                                      <MenuItem value={"Medium"}>
                                        Medium
                                      </MenuItem>
                                      <MenuItem value={"High"}>High</MenuItem>
                                    </Select>
                                    <FormHelperText>
                                      {errors?.priority}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                  <FormControl
                                    disabled={jobPostFormMode === "Preview"}
                                  >
                                    <FormLabel id="demo-row-radio-buttons-group-label" className={classes.labelText2}>
                                      Mode of Working
                                    </FormLabel>
                                    <RadioGroup
                                      row
                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                      name="remote_job"
                                      onChange={handleChange}
                                      value={jobPostData?.remote_job}
                                      sx={{ mt: -1, height: "32px" }}
                                    >
                                      <FormControlLabel
                                        value="On Premise"
                                        control={<Radio size="small" />}
                                        label="On Premise"
                                      />
                                      <FormControlLabel
                                        value="Remote"
                                        control={<Radio size="small" />}
                                        label="Remote"
                                      />
                                      <FormControlLabel
                                        value="Hybrid"
                                        control={<Radio size="small" />}
                                        label="Hybrid"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                  <FormControl
                                    disabled={jobPostFormMode === "Preview"}
                                  >
                                    <FormLabel id="demo-row-radio-buttons-group-label" className={classes.labelText2}>
                                      Preferred Gender
                                    </FormLabel>
                                    <RadioGroup
                                      row
                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                      name="preferred_gender"
                                      onChange={handleChange}
                                      value={jobPostData?.preferred_gender}
                                      sx={{ mt: -1, height: "32px" }}
                                    >
                                      <FormControlLabel
                                        value="All"
                                        control={<Radio size="small" />}
                                        label="Any"
                                      />
                                      <FormControlLabel
                                        value="Male"
                                        control={<Radio size="small" />}
                                        label="Male"
                                      />
                                      <FormControlLabel
                                        value="Female"
                                        control={<Radio size="small" />}
                                        label="Female"
                                      />
                                      <FormControlLabel
                                        value="Non-Binary"
                                        control={<Radio size="small" />}
                                        label="Non-Binary"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                                  <FormControl
                                    disabled={jobPostFormMode === "Preview"}
                                  >
                                    <FormLabel id="demo-row-radio-buttons-group-label" className={classes.labelText2}>
                                      Do you wish to make this job public?
                                    </FormLabel>
                                    <RadioGroup
                                      row
                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                      name="make_public"
                                      onChange={handleChange}
                                      value={jobPostData?.make_public}
                                      sx={{ mt: -1, height: "32px" }}
                                    >
                                      <FormControlLabel
                                        value={true}
                                        control={<Radio size="small" />}
                                        label="Yes"
                                      />
                                      <FormControlLabel
                                        value={false}
                                        control={<Radio size="small" />}
                                        label="No"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                </Grid>

                                {jobPostFormMode !== "Preview" ||
                                  jobPostData.roles_responsibilities ||
                                  jobPostData.description ? (
                                  <Grid
                                    item
                                    xs={12}
                                    md={12}
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      alignItems: "space-between",
                                      p: 2,
                                      minHeight: "300px",
                                    }}
                                  >
                                    {jobPostFormMode !== "Preview" && (
                                      <>
                                        <Grid item xs={6} md={6}>
                                          <Typography className={classes.labelText}>
                                            Job Description
                                          </Typography>
                                          <Quill
                                            name="description"
                                            value={description}
                                            setValue={setDescription}
                                            error={Boolean(errors.description)}
                                            style={{ 
                                              height: "250px", 
                                              backgroundColor: "#ffffff" 
                                            }}
                                          />
                                          {errors?.description && (
                                            <Typography
                                              sx={{
                                                color: "red",
                                                paddingLeft: "20px",
                                                paddingTop: 6,
                                              }}
                                            >
                                              {errors?.description}
                                            </Typography>
                                          )}
                                        </Grid>
                                        <Grid item xs={6} md={6} marginLeft={2}>
                                          <Typography className={classes.labelText}>
                                            Roles and Responsibilities
                                          </Typography>
                                          <Quill
                                            name="roles_responsibilities"
                                            value={rolesresponsibilities}
                                            setValue={setRolesResponsibilities}
                                            style={{ 
                                              height: "250px", 
                                              backgroundColor: "#ffffff" 
                                            }}
                                          />
                                          {errors?.roles_responsibilities && (
                                            <Typography
                                              sx={{
                                                color: "red",
                                                paddingLeft: "20px",
                                                paddingTop: 6,
                                              }}
                                            >
                                              {errors?.roles_responsibilities}
                                            </Typography>
                                          )}
                                        </Grid>
                                      </>
                                    )}
                                    {jobPostFormMode === "Preview" && (
                                      <>
                                        {jobPostData?.description && (
                                          <Grid
                                            item
                                            xs={6}
                                            md={6}
                                          >
                                            <Typography className={classes.labelText}>
                                              Job Description
                                            </Typography>
                                            <Box
                                              className={classes.htmlPreviewBox}
                                            >
                                              <div
                                                className="html-contentJD"
                                                dangerouslySetInnerHTML={{
                                                  __html: jobPostData?.description,
                                                }}
                                              />
                                            </Box>
                                          </Grid>
                                        )}
                                        {jobPostData?.roles_responsibilities && (
                                          <Grid item xs={6} md={6} ml={2}>
                                            <Typography className={classes.labelText}>
                                              Roles and Responsibilities
                                            </Typography>
                                            <Box
                                              className={classes.htmlPreviewBox}
                                            >
                                              <div
                                                className="html-contentJD"
                                                dangerouslySetInnerHTML={{
                                                  __html: jobPostData?.roles_responsibilities,
                                                }}
                                              />
                                            </Box>
                                          </Grid>
                                        )}
                                      </>
                                    )}
                                  </Grid>
                                ) : (
                                  ""
                                )}
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </Box>
                </Paper>
                {jobPostFormMode === "Preview" && isLoading ? (
                  <>
                    <Grid container direction="row" alignItems="center">
                      {Array(8)
                        .fill()
                        .map((data, index) => (
                          <Grid
                            key={index}
                            item
                            p={1.5}
                            lg={6}
                            md={6}
                            sm={6}
                            xs={12}
                          >
                            <Card>
                              <CardHeader
                                action={null}
                                title={
                                  <Skeleton
                                    animation="wave"
                                    height={10}
                                    width="80%"
                                    style={{ marginBottom: 6 }}
                                  />
                                }
                                subheader={
                                  <Skeleton
                                    animation="wave"
                                    height={10}
                                    width="40%"
                                    style={{ marginBottom: 6 }}
                                  />
                                }
                              />
                              <Skeleton
                                sx={{ height: 130 }}
                                animation="wave"
                                variant="rectangular"
                              />
                              <CardContent>
                                <>
                                  <Skeleton
                                    animation="wave"
                                    height={10}
                                    style={{ marginBottom: 6 }}
                                  />
                                  <Skeleton
                                    animation="wave"
                                    height={10}
                                    width="80%"
                                  />
                                </>
                              </CardContent>
                            </Card>
                          </Grid>
                        ))}
                    </Grid>
                  </>
                ) : (
                  <>
                    {jobPostFormMode === "Preview" && (
                      <Box
                        sx={{
                          p: 2,
                          mt: 4,
                          backgroundColor: "white",
                          borderRadius: "10px",
                        }}
                      >
                        <Typography variant="h5" sx={{ ml: 1, pb: 1 }}>
                          Suggested Candidates
                        </Typography>
                        {showCandidate > 0 && (
                          <Typography
                            sx={{ mb: 2 }}
                            display="flex"
                            justifyContent="center"
                          >
                            {" "}
                            Candidates Not Available{" "}
                          </Typography>
                        )}
                        <Grid
                          container
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={1}
                        >
                          {getsuggestions?.map((su, index) => (
                            <Grid
                              sx={{ padding: "10px" }}
                              key={index}
                              item
                              xs={12}
                              sm={6}
                              md={6}
                              lg={6}
                            >
                              <Card sx={{ padding: "14px" }}>
                                <Box sx={{ paddingRight: "8px" }}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      WebkitBoxPack: "justify",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      width: "100%",
                                    }}
                                  >
                                    <Tooltip
                                      placement="bottom-start"
                                      title="Name"
                                    >
                                      <Typography
                                        sx={{ mb: 0 }}
                                        variant="subtitle2"
                                        gutterBottom
                                      >
                                        {su?.first_name} {su?.last_name || ""}
                                      </Typography>
                                    </Tooltip>
                                    <IconButton
                                      onClick={() => !handleDisabled("job_post_propose_candidate") ? dispatch(PowerUserDisabledAction()) : proposeCandidate(su)}
                                    >
                                      <Tooltip title="Propose">
                                        <PersonAddAlt1Icon
                                          color="success"
                                          fontSize="small"
                                        />
                                      </Tooltip>
                                    </IconButton>
                                  </Box>
                                  <Divider sx={{ mb: 2 }} variant="middle" />
                                  <Grid
                                    sx={{ cursor: "Pointer" }}
                                    onClick={() => handleClickPreview(su)}
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <Grid item xs={12} sm={6} md={6} lg={6}>
                                      <Tooltip
                                        placement="bottom-start"
                                        title="Email"
                                      >
                                        <span style={{ display: "flex" }}>
                                          <EmailIcon fontSize="small" />
                                          <Typography
                                            pl={1}
                                            variant="body2"
                                            gutterBottom
                                          >
                                            {su?.email_id}
                                          </Typography>
                                        </span>
                                      </Tooltip>
                                      <Tooltip
                                        placement="bottom-start"
                                        title="Location"
                                      >
                                        <span style={{ display: "flex" }}>
                                          <LocationOnRoundedIcon fontSize="small" />
                                          <Typography pl={1} variant="body2">
                                            {su?.location || "-"}
                                          </Typography>
                                        </span>
                                      </Tooltip>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6} lg={6}>
                                      <Tooltip
                                        placement="bottom-start"
                                        title="Primary Skills"
                                      >
                                        <span style={{ display: "flex" }}>
                                          <PsychologyIcon fontSize="small" />
                                          <Typography
                                            pl={1}
                                            variant="body2"
                                            gutterBottom
                                          >
                                            {su?.primary_skill}
                                          </Typography>
                                        </span>
                                      </Tooltip>
                                      <Tooltip
                                        placement="bottom-start"
                                        title="Secondary Skills"
                                      >
                                        <span style={{ display: "flex" }}>
                                          <PsychologyIcon fontSize="small" />
                                          <Typography pl={1} variant="body2">
                                            {su?.secondary_skill || "-"}
                                          </Typography>
                                        </span>
                                      </Tooltip>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                      <LinearProgress
                                        className="progress-value"
                                        variant="determinate"
                                        value={
                                          su?.profile_score
                                            ? su?.profile_score
                                            : 0
                                        }
                                      />
                                      <span
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <Typography pl={1} variant="body2">
                                          {su?.profile_score
                                            ? `${su?.profile_score}%`
                                            : "0%"}
                                        </Typography>
                                      </span>
                                    </Grid>
                                  </Grid>
                                </Box>
                              </Card>
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                    )}
                    {getsuggestions?.[0]?.total_count > 12 && (
                      <Pagination
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          mb: 2,
                        }}
                        showFirstButton
                        showLastButton
                        count={
                          Number.isInteger(
                            getsuggestions?.[0]?.total_count / 12
                          )
                            ? getsuggestions?.[0]?.total_count / 12
                            : Math.round(
                              getsuggestions?.[0]?.total_count / 12 + 0.5
                            ) || 0
                        }
                        page={page}
                        color="secondary"
                        onChange={(event, value) =>
                          handlePagination(event, value)
                        }
                      />
                    )}
                  </>
                )}
              </Box>
            </>
          )}
          {
            <AtsJobTemplatePreview
              anchor={anchor}
              toggleDrawer={toggleDrawer}
              drawerdata={drawerdata}
              handleApplyTemplate={handleApplyTemplate}
              jobPostData={jobPostData}
              setPostJobData={setPostJobData}
            />
          }

          {jobPostFormMode === "Preview" && (
            <ConfirmationDialog
              title="Propose Candidate"
              content={`Do you wish to Propose ${data?.first_name} to ${editedRecord.title}?`}
              anchorE={anchorE}
              openDialog={openDialog}
              closeDialog={setOpenDialog}
              popupTitle="Job"
              OkButtonText="Yes Propose"
              onSubmit={handleConfirmPropose}
            />
          )}
          <Popup
            title={"Feed Back Template"}
            openPopup={formBuilder}
            setOpenPopup={setFormBuilder}
            maxWidth="md"
            fullWidth={true}
          >
            <FormBuilder
              formBuilder={formBuilder}
              setFormBuilder={setFormBuilder}
              JD={true}
              title={builderTitle}
            />
          </Popup>
          <Popup
            title={"Pre-Screen Assessment Template"}
            openPopup={preformBuilder}
            setOpenPopup={setPreFormBuilder}
            maxWidth="md"
            fullWidth={true}
          >
            <PreScreen
              preformBuilder={preformBuilder}
              setPreFormBuilder={setPreFormBuilder}
              JD={true}
              title={prebuilderTitle}
              setPostJobData={setPostJobData}
              setPreBuilderTitle={setPreBuilderTitle}
              handlepreScreenTemplateLoading={handlepreScreenTemplateLoading}
            />
          </Popup>
          {/* Edit Screening Question */}
          <Popup
            title={"Edit Screening Question"}
            openPopup={editDialogOpen}
            setOpenPopup={(v) => {setEditDialogOpen(v); setPreBuilderTitle("")}}
            maxWidth="md"
            fullWidth={true}
          >
            <EditScreeningQuestionsDialog
              open={editDialogOpen}
              onClose={() => {setEditDialogOpen(false); setPreBuilderTitle("")}}
              jobPostData={jobPostData}
              setPostJobData={setPostJobData}
              prescreenTemplate={prescreenTemplate}
              handlepreScreenTemplateLoading={handlepreScreenTemplateLoading}
              handleChange={handleChange}
              errors={errors}
              rolesresponsibilities={rolesresponsibilities}
              description={description}
              prebuilderTitle={prebuilderTitle}
              setPreBuilderTitle={setPreBuilderTitle}
              populateDefaultPreScreeningTemplate={populateDefaultPreScreeningTemplate}
            />
          </Popup>
        </>
      )}
    </>
  );
};
const useStyles = makeStyles(() =>
  createStyles({
    mainContainer: {
      overflowY: "auto",
      height: "calc(100vh - 75px)",
      position: "relative",
      paddingBottom: "8px"      
    },
    PaperContainer: {
      borderRadius: "10px",
      p: 1.5,
      overflowY: "auto",
      backgroundColor: "transparent",
      boxShadow: "none",
    },
    paper: {
      borderRadius: "10px",
      padding: "16px",
      overflowY: "auto"
    },
    headerContainer: {
      marginBottom: "24px",
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: "0 12px 0 8px"
    },
    title: {
      fontSize: '1.5rem',
      fontWeight: 700,
      marginBottom: '4px',
      color: "inherit"
    },
    subtitle: {
      fontSize: '0.875rem',
      color: '#666'
    },
    aiBadge: {
      background: `linear-gradient(90deg, #8a3ffc 0%, #c43af3 50%, #ff2e74 100%)`,
      color: 'white',
      fontWeight: 600,
      fontSize: '0.75rem',
      '& .MuiChip-icon': {
        color: 'white',
      },
    },
    previewCardParent: {
      marginRight: "8px",
      overflow:"hidden",
      borderRadius: "16px",
      border: "4px solid rgb(243,237,253)",
      backdropFilter: "blur(4px)",
      backgroundColor: "rgba(255, 255, 255, 0.85)",
      boxShadow: "0 8px 30px rgba(99, 102, 241, 0.15)",
      backgroundImage: `
        radial-gradient(circle at 20% 30%, rgba(179,136,235,0.12) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(244,143,177,0.12) 0%, transparent 50%),
        radial-gradient(circle at 50% 80%, rgba(135,206,235,0.1) 0%, transparent 50%)
      `,
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
    previewCard: {
      position: "relative",
      minHeight: "300px",
      maxHeight: "calc(100vh - 170px)",
      borderRadius: "16px",
      padding: "16px",
      overflowY: "auto",
    },
    fieldCard: {
      position: "relative",
      borderRadius: "16px",
      padding: "16px",
      overflow: "hidden",
      backdropFilter: "blur(4px)",
      backgroundColor: "rgba(255, 255, 255, 0.85)",
      boxShadow: "0 8px 30px rgba(99, 102, 241, 0.15)",
      border: "4px solid rgb(243,237,253)",
      backgroundImage: `
        radial-gradient(circle at 20% 30%, rgba(179,136,235,0.12) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(244,143,177,0.12) 0%, transparent 50%),
        radial-gradient(circle at 50% 80%, rgba(135,206,235,0.1) 0%, transparent 50%)
      `,
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
    previewHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      marginBottom: '16px'
    },
    labelText: {
      fontSize: "1rem",
      fontWeight: 500,
      lineHeight: 1.6,
      color: "inherit"
    },
    labelText2: {
      fontSize: "0.9rem",
      fontWeight: 500,
      color: "inherit"
    },
    Backdrop: {
      zIndex: 1,
      backgroundColor: "rgba(255, 255, 255, 0.5)",
      position: "absolute",
      borderRadius: "inherit",
    },
    htmlPreviewBox:{
      borderRadius: "8px",
      padding: "12px 16px",
      overflowY: "auto",
      maxHeight: "300px",
      border: "1px solid rgba(0,0,0,0.1)",
      marginTop: "4px",
    }
  })
);
const normalizeFrequency = (freq, total) => {
  const num = Number(freq);
  const totalNum = Number(total);

  if (total == null || isNaN(totalNum)) return "";

  //empty freq → default to total
  if (freq === "" || freq == null || isNaN(num)) return totalNum;
  // cap to total
  if (num > totalNum) return totalNum;

  // prevent negative
  if (num < 0) return totalNum;

  return num;
};
export default AtsJobPostForm;